import { DatePipe, TitleCasePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainComponent } from "src/app/app.main.component";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import { AppMainService } from "src/app/app-main.service";
import { catchError, finalize, forkJoin, from, map, of, Subject, takeUntil, tap } from "rxjs";
import { AccountsHttpService } from "src/app/modules/shared/services/accounts.http.service";
import { ShippingtermService } from "src/app/configurations/inventory/setup/shippingterm/shippingterm.service";
import * as _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { ProductDataService } from "src/app/modules/shared/services/product-data.service";
import { ImportserialService } from "src/app/modules/shared/services/importserial.service";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountModuleId } from "src/app/modules/shared/constants/modules.constant";
import { SharedChannelService } from "src/app/modules/shared/services/channel.service";
import { ShippingmethodService } from "src/app/configurations/inventory/setup/shippingmethod/shippingmethod.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { ApprovalStatus, ContactSelectionType, DialogType, SOChannel, SOObjectNames, TemplateType, TypeIds, accHoldMsg } from "src/app/inventory/sales-order/constants/constants";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { ProductCalculationUtilityService } from "src/app/inventory/sales-order/utils/product-calculation-utility.service";
import { EstimateNewStatus, Severity, Status } from "src/app/inventory/constants/constants";
import { INote } from "src/app/inventory/sales-order/models/note.model";
import { ProductsService } from "src/app/inventory/products/products.service";
import { AccountFlatteningService } from "src/app/inventory/sales-order/services/account-flattening.service";
import { IBundleProductList, IEstimate, IEstimateAddDiscount, IEstimateAudit, IEstimateBundleProduct, IEstimateNote, IEstimateProduct, IEstimateProductSubTax, IProductList } from "src/app/inventory/sales-order/models/estimate.model";
import { OpportunitiesService } from "src/app/opportunities-v2/services/opportunity.service";
import { ProductListingDataBuilderService } from "./service/product-listing-data-builder.service";
import { CreditControlEnum } from "src/app/models/statusEnums";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";
import { OverlayPanel } from "primeng/overlaypanel";
import { DialogTypeFeeOrDiscount, Fee, FeeOrDiscountContext } from "../fees-and-discounts-manager/models/fee.model";
import { TaxSelectionModel } from "../tax-selection-modal/models/tax.model";

@Component({
    selector: "app-estimates-add-edit",
    templateUrl: "./estimates-add-edit.component.html",
    styleUrls: ["./estimates-add-edit.component.scss"],
})
export class EstimatesAddEditComponent implements OnInit, OnChanges, OnDestroy {
    @Input() type;
    @Input() dialogHeader;
    @Input() displayEstimateAdd;
    @Input() selectedEstimate: any;
    @Input() selectedRPO: any;
    @Input() selectedOpportunity: any;
    @Input() selectedChannel: any;

    @Output() estimateDialogClose = new EventEmitter();
    @Output() cancel = new EventEmitter();
    @Output() onVoidEstimate = new EventEmitter();
    @Output() onListEstimate = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    @ViewChild("editor") editor: any;
    @ViewChild("editCurrency") overlayPanel: OverlayPanel;

    templates: any;
    allCustomAttributes: any;
    allTax: any[] = [];
    allShippingMethods: any[] = [];
    allPaymentTerms: any[] = [];
    allPaymentMethods: any[] = [];
    allShippingTerms: any[] = [];
    allUser: any[] = [];
    allLocations: any[] = [];
    orderChannels: any[] = [];
    shippingMethods: any[] = [];
    aggregateDiscount: boolean = false;
    pricebookConfig: boolean = false;
    filteredSection: any[] = [];
    billingAddressType: any;
    shippingAddressType: any;
    estimateObjectId: number;
    orderObjId: number;
    accountChannels: any[] = [];
    sOpportunity: any;

    combinedCustomFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };

    discountEnabled = false;
    footerTaxEnabled = false;
    isVisibleFooterTax = false;
    isVisibleFooterDiscount = false;
    contactType = ContactSelectionType;
    typeIds = TypeIds;
    dialogType = DialogType;
    accountInfo;
    accountAddressInfo;
    shippingAddressInfo;
    contactInfo;
    selectedAccountAddress;
    selectedShippingAddress;
    orderStatusDD: any[] = [];
    minimumDate = this.app._showDateTimeWithZone(new Date());
    minExpiryDate: Date = new Date(2000, 0, 1);
    allAccountsDD: any[] = [];
    displayAccountAddress = false;
    displayShippingAddress = false;
    allStages: any[] = [];
    allStatus: any[] = [];
    minDate: Date = new Date(2000, 0, 1);
    maxDate: Date = new Date(2050, 11, 31);
    statementMessege: string = "";

    //product
    productsData;
    allProductsData: IProductList[] = [];
    purchaseListTB: IProductList[] = [];
    selectedProductsList: IProductList[] = [];
    selectedBundle;
    orderTotal = 0;
    sumTotal = 0;
    discount: number = 0;
    taxRate: number = 0;
    tax: number = 0;
    productsTotal: number = 0;
    locationDD;
    displayScanInfo;
    triangle = "fa fa-caret-down";
    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files
    estForm: FormGroup;

    // serial
    trackingForm: FormGroup;
    listLength = 0;
    nameLists: any[] = [];
    noCaseFindOrLoadingText = "";
    accHoldMsg: string = "";
    disableLocation = true;
    estDetails;
    taxDesc;
    selectedLocation;
    selectedProductForScan;
    selectedBundleForScan;
    displayOpenWarehouseList = false;
    warehouseLists: any[] = [];
    selectedWarehouseList;
    displayProductSelectionModal = false;
    moduleName: string = SOChannel.ESTIMATES;
    isVisibleLocation = false;
    selectedLocationId = 0;
    headerText = "Products List";
    autoResize = true;
    billingAddressContact;
    displayContactSelectionModal = false;
    contactSelectionModalType = "";
    selectedContact;
    isVisibleRowTax = false;
    isVisibleRowDiscount = false;
    cols = 0;
    isDisabled: boolean = false;
    allAccounts: any[] = [];
    estimateStatus = EstimateNewStatus;
    soChannel = SOChannel;
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number;
    selectedAccountChannelId: number;
    selectedProduct;
    opportunities: any[] = [];

    /** Estimate Context Menu */
    isContextMenuVisible = false;
    productconfigMenu = [
        {
            label: "Copy",
            icon: "pi pi-copy",
            visible: true,
            command: () => {
                this.copyProduct();
            },
        },
    ];

    /** Additional Discounts */
    discountOptions: any[] = [];
    additionalDiscounts: any = [];
    additionalDiscountRateTypes: any = [];
    additionalDiscountAmount: Number = 0;

    /** Tax */
    taxSettings: any;
    taxConfig: any;
    allTaxRates: any[] = []; // account based taxes
    subTaxCodeNames = "";
    orderTotalTax = 0;
    displayTaxSelectionDialog: boolean = false;
    selectedTax: any;
    appliedTax: any;
    currentProduct: any;
    currentProductType: string;
    taxDialogContext: "product" | "footer" | null = null;

    // additional Fees
    additionalFees: any[] = [];
    totalAdditionalFee: number = 0;
    productsTotalAdditionalFee: number = 0;

    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;

    currencies = [];
    // currency
    baseCurrency: any;
    orgCurrency = [];
    measurementUnits = [];
    decimalPlacesMap: { [key: number]: number } = {};
    currencyExchangeRate: number;
    savedCurrencyExchangeRate: number;
    previousCurrencyExchangeRate: number;

    /** Opportunity to Quotation */
    showOpportunitySelectionDialog: boolean = false;
    //footer & line level discount & fee
    selectedDProduct: any = null;
    selectedHProduct: any = null;
    lineLevelDiscounts: any[] = [];
    footerLevelDiscounts: any[] = [];
    lineLevelHandlingFees: any[] = [];
    footerLevelHandlingFees: any[] = [];
    FeeOrDiscountContext = FeeOrDiscountContext;
    feeOrDiscountContext: FeeOrDiscountContext;
    DialogTypeFeeOrDiscount = DialogTypeFeeOrDiscount;
    currentDialogType: DialogTypeFeeOrDiscount;
    displayFeeOrDiscountDialog = false;
    isFooterDiscount: boolean = false;

    constructor(
        public app: AppMainComponent,
        private fb: FormBuilder,
        private salesOrderService: SalesOrderService,
        private messageService: MessageService,
        public datepipe: DatePipe,
        private appMainService: AppMainService,
        private utilityService: UtilityService,
        private confirmationService: ConfirmationService,
        private accountsHttpService: AccountsHttpService,
        private shippingtermService: ShippingtermService,
        private productsService: ProductsService,
        private productDataService: ProductDataService,
        private importService: ImportserialService,
        private renderer: Renderer2,
        private accountServiceN: AccountServiceN,
        private accountFlatteningService: AccountFlatteningService,
        private sharedChannelService: SharedChannelService,
        private shippingMethodService: ShippingmethodService,
        private opportunitiesService: OpportunitiesService,
        private titlecasePipe: TitleCasePipe,
        private productListingDataBuilderService: ProductListingDataBuilderService,
        private productCalculationUtilityService: ProductCalculationUtilityService,
    ) {}

    ngOnInit(): void {
        const allModules = this.app.preLoadedObjects.filter((obj) => obj.name == "Orders");
        this.orderObjId = allModules.find((el) => el.name == "Orders")?.id;
        this.estimateObjectId = this.app.preLoadedObjects.find((obj) => obj.name == SOObjectNames.Estimate)?.id;
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.fetchUnitOfMeasureCategories();
        this.getBaseCurrency();
        this.initForm();
        this.utilityService.getFilteredSectionsByType(0).subscribe((res) => {
            this.filteredSection = res;
        });
        this.getAllCustomAttributes();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayEstimateAdd && changes.displayEstimateAdd.currentValue) {
            this.displayEstimateAdd = changes.displayEstimateAdd.currentValue;
            this.initCustomFields();
            this.isDisabled = false;
        }
        if (changes.type && changes.type.currentValue) {
            this.type = changes.type.currentValue;
            this.initForm();
            this.loadData();
        }
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    fetchUnitOfMeasureCategories() {
        this.salesOrderService.fetchUnitOfMeasureCategories().subscribe((resp) => {
            this.measurementUnits = resp;
        });
    }
    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }
    loadData() {
        this.appMainService.isShowSpinner("loadData");
        const templateObservable = this.salesOrderService.getAllOrdersChannel("Orders Template").pipe(catchError((error) => this.handleError("Template", error)));
        const taxObservable = this.salesOrderService.getAllTax().pipe(catchError((error) => this.handleError("Payment Term", error)));
        const orderChannelsObservable = this.salesOrderService.getAllOrdersChannel("Orders Type").pipe(catchError((error) => this.handleError("Order Channels", error)));
        const shippingTermObservable = this.shippingtermService.getShippingTermList().pipe(catchError((error) => this.handleError("Shipping Term", error)));
        const allUserObservable = this.salesOrderService.getAllUser().pipe(catchError((error) => this.handleError("All User", error)));
        const allLocationObservable = this.salesOrderService.getAllLocations("0", "0", "").pipe(catchError((error) => this.handleError("All Location", error)));
        const allTiersObservable = this.productsService.getAllTiers().pipe(catchError((error) => this.handleError("All Tiers", error)));
        const discountSelectionObservable = this.salesOrderService.getAllDiscountOption("TierApplicationRule").pipe(catchError((error) => this.handleError("Discount Selection", error)));
        const additionalDiscountObservable = this.salesOrderService.getDiscounts(false).pipe(catchError((error) => this.handleError("Discount", error)));
        const additionalFeesObservable = this.salesOrderService.getAdditionalFees().pipe(catchError((error) => this.handleError("Additional Fees", error)));
        const addressTypeObservable = this.salesOrderService.getAddressTypes().pipe(catchError((error) => this.handleError("Address Type", error)));
        const accountChannelOservable = this.sharedChannelService.getChannels(AccountModuleId).pipe(catchError((error) => this.handleError("Account Channel", error)));
        const discountConfigObservable = this.salesOrderService.getAllDiscount().pipe(catchError((error) => this.handleError("Discount", error)));
        const shippingMethodObservable = this.shippingMethodService.getShippingMethodList().pipe(catchError((error) => this.handleError("Shipping Method", error)));

        forkJoin([templateObservable, taxObservable, orderChannelsObservable, shippingTermObservable, allUserObservable, allLocationObservable, allTiersObservable, discountSelectionObservable, additionalDiscountObservable, additionalFeesObservable, addressTypeObservable, accountChannelOservable, discountConfigObservable, shippingMethodObservable]).subscribe(
            ([allTemplates, taxData, orderChannelData, shippingTermData, allUserData, allLocationData, allTiersData, discountSelectionData, additionalDiscounts, additionalFees, addressTypes, accountChannels, discountConfig, shippingMethods]) => {
                this.setTemplate(allTemplates);
                this.setAllTaxData(taxData);
                this.setOrderChannelData(orderChannelData);
                this.setShippingTermData(shippingTermData);
                this.setAllUserData(allUserData);
                this.setAllLocationData(allLocationData);
                this.setAllTiersData(allTiersData);
                this.setDiscountSelectionData(discountSelectionData);
                this.setAdditionalDiscounts(additionalDiscounts);
                this.setAdditionalFees(additionalFees);
                this.setAddressTypes(addressTypes);
                this.setAccountChannels(accountChannels);
                this.setDiscountConfig(discountConfig);
                this.setShippingMethods(shippingMethods);

                if (this.type && this.type == DialogType.CREATE) {
                    this.filterActiveAccounts();
                    this.initEstimateCreate();
                } else if (this.type && [DialogType.EDIT, DialogType.COPY, DialogType.VIEW].includes(this.type)) {
                    this.initEstimateEdit();
                }
                this.appMainService.isHideSpinner("loadData");
            },
            (error) => {
                this.appMainService.isHideSpinner("loadData");
                this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
            },
        );
    }

    initForm() {
        this.estForm = this.fb.group({
            id: [0],
            accountChannel: [this.accountChannels?.filter((ac) => ac.isDefault == true)[0]],
            account: ["", Validators.required],
            estimateDate: [this.app._showDateTimeWithZone(new Date())],
            expiryDate: [this.app._showDateTimeWithZone(new Date())],
            estimateStatusId: [null, Validators.required],
            referenceNumber: [""],
            shippingChargeAmount: [0],
            taxAmount: [0],
            discountType: [null],
            discountValue: [0],
            vendorMessage: [""],
            memo: [""],
            paymentTerm: [""],
            paymentMethod: [""],
            shippingTerm: [""],
            shippingMethod: [""],
            salesRep: [""],
            tax: [""],
            location: [this.allLocations?.filter((ac) => ac.isDefault == true)[0]],
            statusId: [true],
            additionalDiscountRate: [0],
            additionalDiscountType: [null],
            additionalDiscountTypeName: [null],
            additionalFeeType: [null],
            additionalFee: [0],
            opportunity: [null],
        });
        this.minDate = new Date(2000, 0, 1);
        this.maxDate = new Date(2050, 11, 31);
    }

    /** Initialize estimate form and other data for creating new estimate */
    initEstimateCreate() {
        this.initForm();
        this.accountInfo = null;
        this.accountAddressInfo = null;
        this.shippingAddressInfo = null;
        this.selectedAccountAddress = null;
        this.selectedShippingAddress = null;
        this.billingAddressContact = null;
        this.sumTotal = 0;
        this.orderTotal = 0;
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.combinedCustomFields = this.utilityService.getCustomAttributesForCommon(this.templates, this.allCustomAttributes);

        // set default values
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];
        if (this.shippingMethods && this.shippingMethods?.length > 0) {
            this.estForm.controls["shippingMethod"].setValue(this.shippingMethods.filter((sm) => sm.isDefault == true)[0]);
        }
        if (this.allAccounts && this.allAccounts.length) {
            this.estForm.controls["accountChannel"].setValue(this.accountChannels?.filter((ac) => ac.isDefault == true)[0]);
        }
        if(this.accountChannels && this.accountChannels?.length > 0) {
            this.estForm.controls["accountChannel"].setValue(this.accountChannels?.filter((ac) => ac?.id == this.selectedChannel?.id)[0]);
        }
        this.estForm.controls["estimateStatusId"].setValue(this.allStatus[0]);
        this.estForm.controls["estimateDate"].setValue(this.app._showDateTimeWithZone(new Date()));
        this.estForm.controls["expiryDate"].setValue(this.app._showDateTimeWithZone(new Date()));
        this.estForm.controls["tax"].setValue(this.taxDesc);
        this.estForm.controls.opportunity.setValue(this.selectedOpportunity ?? null);
        this.taxRate = this.taxDesc && this.taxDesc?.taxRate ? this.taxDesc?.taxRate : 0;
        this.setOpportunityToQuotationData();
        this.minExpiryDate = this.app._showDateTimeWithZone(new Date());
    }

    /** Opportunity to Quotation */
    openOpportunitySelectionDialog() {
        if (!this.selectedOpportunity && !this.selectedOpportunity?.id) {
            this.showOpportunitySelectionDialog = true;
        }
    }
    onCancelOpportunitySelection(event) {
        this.showOpportunitySelectionDialog = false;
    }
    onSelectOpportunity(event) {
        this.sOpportunity = event?.selectedOpportunity ?? null;
        this.sOpportunity["opportunityNo"] = this.sOpportunity?.name + " - " + this.sOpportunity?.sequenceNumber;
        this.showOpportunitySelectionDialog = false;
        this.getOpportunityDetailsById(this.sOpportunity?.id);
    }
    removeOpportunity() {
        this.sOpportunity = null;
    }
    getOpportunityDetailsById(id: number) {
        this.appMainService.isShowSpinner("getOpportunityDetailsById");
        this.opportunitiesService.getOpportunityById(id).subscribe({
            next: (opportunityDetail: any) => {
                this.selectedOpportunity = opportunityDetail;
                this.setOpportunityToQuotationData();
                this.appMainService.isHideSpinner("getOpportunityDetailsById");
            },
            error: (error: Error) => {
                this.appMainService.isHideSpinner("getOpportunityDetailsById");
                this.messageService.add({
                    severity: "error",
                    summary: "Error!",
                    detail: "Error occurring when fetching opportunity details. Please try after sometimes.",
                });
            },
        });
    }
    getDecimalPlacesCached(categoryId: number): number {
        if (!(categoryId in this.decimalPlacesMap)) {
            this.decimalPlacesMap[categoryId] = this.getDecimalPlaces(categoryId);
        }
        return this.decimalPlacesMap[categoryId];
    }
    getDecimalPlaces(categoryId: number): number {
        return this.measurementUnits?.some((unit) => unit.id === categoryId && unit.name?.toLowerCase() === "count") ? 0 : this.qtyFractionDigits;
    }
    async setOpportunityToQuotationData() {
        if (this.selectedOpportunity && this.selectedOpportunity.id) {
            this.sOpportunity = { ...this.selectedOpportunity, opportunityNo: this.selectedOpportunity.name + " - " + this.selectedOpportunity.sequenceNumber };
        }
        if (this.selectedOpportunity && this.selectedOpportunity.accountId) {
            await this.selectAccount({ id: this.selectedOpportunity.accountId });
        }
        if (this.selectedOpportunity && this.selectedOpportunity.opportunityProducts && this.selectedOpportunity.opportunityProducts.length > 0) {
            const products = this.productListingDataBuilderService.transformOpportunityProductsToQuotationFormat(this.selectedOpportunity.opportunityProducts, this.discountOptions, this.additionalFees);
            this.onProductAddComplete(products);
        }
        if (this.selectedOpportunity && this.selectedOpportunity.id) {
            this.setOpportunityToQuotationFormValues();
        }
        this.calculateOrderTotal();
    }

    setOpportunityToQuotationFormValues() {
        const statusDraft = this.allStatus?.find((s) => s.id == EstimateNewStatus.Draft); // Draft status
        const discType = this.selectedOpportunity.discountId ? this.discountOptions?.filter((v) => v.id == this.selectedOpportunity.discountId)[0] : null;
        const additionalDiscount = this.selectedOpportunity?.opportunityAddDiscount && this.selectedOpportunity.opportunityAddDiscount.length > 0 ? this.selectedOpportunity.opportunityAddDiscount[0] : null;
        this.additionalDiscountRateTypes = [additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null];
        const location = this.selectedOpportunity && this.selectedOpportunity?.opportunityProducts && this.selectedOpportunity?.opportunityProducts.length > 0 ? this.allLocations.find((l) => l.id == this.selectedOpportunity.opportunityProducts?.[0]?.warehouseId) : this.allLocations.find((l) => l.isDefault);

        let opportunity = null;
        if (this.selectedOpportunity?.opportunityId) {
            opportunity = {
                id: this.selectedOpportunity?.opportunityId,
                name: this.selectedOpportunity?.opportunityNo,
            };
        }
        const currentYear = this.app._showDateTimeWithZone(this.selectedOpportunity?.createdDate).getFullYear();
        this.minDate = new Date(currentYear, 0, 1);
        this.maxDate = new Date(2050, 11, 31);
        this.minExpiryDate = this.app._showDateTimeWithZone(this.selectedOpportunity.createdDate);
        // this.setMinExpiryDate(this.app._showDateTimeWithZone(this.selectedOpportunity.createdDate));
        this.estForm.patchValue({
            ...this.selectedOpportunity,
            account: this.accountInfo,
            accountChannel: this.accountChannels?.filter((ac) => ac.id == this.selectedOpportunity?.account?.typeId)[0],
            location: location,
            estimateDate: this.app._showDateTimeWithZone(new Date(this.selectedOpportunity.createdDate)),
            expiryDate: this.app._showDateTimeWithZone(this.selectedOpportunity.createdDate),
            estimateStatusId: statusDraft,
            discountType: discType,
            discountValue: this.selectedOpportunity?.discountRate ?? 0,
            vendorMessage: "",
            memo: "",
            salesRep: null,
            statusId: this.selectedOpportunity.statusId == 1 ? true : false,
            additionalDiscountRate: additionalDiscount ? additionalDiscount.discountRate : 0,
            additionalDiscountType: additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null,
            additionalDiscountTypeName: additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null,
            shippingMethod: null,
            additionalFeeType: this.additionalFees?.find((af) => af.id == this.selectedOpportunity?.additionalFeesId),
            additionalFee: this.selectedOpportunity?.additionalRate,
            opportunity: opportunity,
            shippingChargeAmount: (Number(this.selectedOpportunity?.shippingChargeAmount ?? 0) * (this.selectedOpportunity?.exchangeRate ?? 1)).toFixed(this.fractionDigits),
        });
    }

    /** Search Opportunity */
    searchOpportunity(event) {
        let query = event.query;
        const accountId = this.estForm?.controls?.account?.value?.id ?? 0;

        this.appMainService.isShowSpinner("getOpportunityList");
        this.opportunitiesService
            .getOpportunityByAccountId(accountId, query, false)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.opportunities = response ?? [];
                    this.appMainService.isHideSpinner("getOpportunityList");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getOpportunityList");
                },
                complete: () => {
                    this.appMainService.isHideSpinner("getOpportunityList");
                },
            });
    }

    /** End Opportunity to Quotation */

    /** Estimate Edit */
    initDefaultValues() {
        this.initForm();
        this.accountInfo = null;
        this.accountAddressInfo = null;
        this.shippingAddressInfo = null;
        this.selectedAccountAddress = null;
        this.selectedShippingAddress = null;
        this.purchaseListTB = [];
        this.sumTotal = 0;
        this.orderTotal = 0;
        this.allProductsData = [];
        this.purchaseListTB = [];
        this.allPaymentTerms = [];
        this.allPaymentMethods = [];
    }
    initEstimateEdit() {
        this.initDefaultValues();
        this.appMainService.isShowSpinner("loadEstimate");
        this.salesOrderService
            .getEstimatesDetailsById(this.selectedEstimate?.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                async (res) => {
                    this.estDetails = res;
                    this.savedCurrencyExchangeRate = Number(this.estDetails.exchangeRate);
                    this.appMainService.isHideSpinner("loadEstimate");
                    this.filterStatus();
                    this.setPaymentTermandMethod();
                    this.templates = this.estDetails && this.estDetails.configJSON ? JSON.parse(this.estDetails.configJSON) : this.templates;
                    this.combinedCustomFields = this.utilityService.getCustomAttributesForCommon(this.templates, this.allCustomAttributes);
                    this.setAccountDetails();
                    this.getColsCount();
                    this.checkTaxDiscountVisibility();
                    this.setFormValues();
                    await this.getTaxByAddress(this.accountAddressInfo?.address?.countryId, this.accountAddressInfo?.address?.stateId);
                    this.discount = this.estDetails.discountAmount;
                    this.taxRate = this.estDetails.tax && this.estDetails.tax.taxRate ? this.estDetails.tax.taxRate : 0;
                    this.prepareProductsListToView();
                    this.estForm.controls.location.disable(); // if type is edit location dropdown is disabled
                    this.prepareCustomFieldsToView();
                    this.calculateOrderTotal();
                    if (this.type == "VIEW") {
                        this.estForm.disable();
                    }
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadEstimate");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred...",
                    });
                },
            );
    }
    setAccountDetails() {
        this.accountInfo = this.estDetails.account;
        this.selectedAccountAddress = this.estDetails.account.accountAddresses.filter((d) => d.addressId == this.estDetails.billingAddressId)[0];
        this.accountAddressInfo = this.selectedAccountAddress;
        this.billingAddressContact = this.estDetails?.contact;
        if (this.accountInfo) {
            this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.["businessName"];
        }
        this.getcurrencyExchangeRate();
    }
    setPaymentTermandMethod() {
        const paymentTerms = [];
        const paymentMethods = [];
        if (this.estDetails?.account?.accountPaymentTerms) {
            this.estDetails?.account?.accountPaymentTerms?.forEach((e) => {
                paymentTerms.push(e.paymentTerm);
            });
        }
        if (this.estDetails?.account?.accountPaymentMethods) {
            this.estDetails?.account?.accountPaymentMethods?.forEach((e) => {
                paymentMethods.push(e.paymentMethod);
            });
        }
        const term = paymentTerms.filter((pt) => pt.id == this.estDetails.paymentTermId)[0];
        if (!term) {
            paymentTerms.push(this.estDetails.paymentTerm);
        }
        const method = paymentMethods.filter((pm) => pm.id == this.estDetails.paymentMethodId)[0];
        if (!method) {
            paymentMethods.push(this.estDetails.paymentMethod);
        }
        this.allPaymentTerms = paymentTerms;
        this.allPaymentMethods = paymentMethods;
    }
    setFormValues(): void {
        const status = this.allStatus?.filter((s) => s.id == this.estDetails?.estimateStatusId)[0];
        const statusDraft = this.allStatus?.find((s) => s.id == EstimateNewStatus.Draft); // Draft status
        const discType = this.estDetails.discountId ? this.discountOptions?.filter((v) => v.id == this.estDetails.discountId)[0] : null;
        const user = this.allUser.filter((u) => u.id == this.estDetails.userId)[0];
        const additionalDiscount = this.estDetails?.estimateAddDiscount && this.estDetails.estimateAddDiscount.length > 0 ? this.estDetails.estimateAddDiscount[0] : null;
        this.additionalDiscountRateTypes = [additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null];
        let opportunity = null;
        if (this.estDetails?.opportunityId) {
            opportunity = {
                id: this.estDetails?.opportunityId,
                name: this.estDetails?.opportunityNo,
            };
        }
        this.sOpportunity = null;
        if (this.estDetails?.opportunityId && this.estDetails?.opportunityId > 0) {
            this.sOpportunity = {
                id: this.estDetails?.opportunityId,
                opportunityNo: this.estDetails?.opportunityNo,
            };
        }
        const currentYear = this.app._showDateTimeWithZone(this.estDetails?.estimateDate).getFullYear();
        this.minDate = new Date(currentYear, 0, 1);
        this.maxDate = new Date(currentYear, 11, 31);
        this.minExpiryDate = this.app._showDateTimeWithZone(this.estDetails.estimateDate);
        this.estForm.patchValue({
            ...this.estDetails,
            account: this.accountInfo,
            accountChannel: this.accountChannels?.filter((ac) => ac.id == this.estDetails?.account?.typeId)[0],
            location: this.allLocations?.filter((ac) => ac.id == this.estDetails?.warehouseId)[0],
            estimateDate: this.app._showDateTimeWithZone(this.estDetails.estimateDate),
            expiryDate: this.app._showDateTimeWithZone(this.estDetails.expiryDate),
            estimateStatusId: this.type == DialogType.COPY ? statusDraft : status,
            discountType: discType,
            discountValue: this.estDetails?.discountRate ?? 0,
            vendorMessage: this.estDetails.estimateAudits && this.estDetails.estimateAudits.length > 0 ? this.estDetails.estimateAudits[this.estDetails.estimateAudits.length - 1].note.comment : "",
            memo: this.estDetails.estimateNotes && this.estDetails.estimateNotes.length > 0 ? this.estDetails.estimateNotes[this.estDetails.estimateNotes.length - 1].note.comment : "",
            salesRep: user,
            statusId: this.estDetails.statusId == 1 ? true : false,
            additionalDiscountRate: additionalDiscount ? additionalDiscount.discountRate : 0,
            additionalDiscountType: additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null,
            additionalDiscountTypeName: additionalDiscount && this.additionalDiscounts && this.additionalDiscounts?.length > 0 ? this.additionalDiscounts?.find((a) => a?.id == additionalDiscount.discountId) : null,
            shippingMethod: this.utilityService.findShippingMethodById(this.shippingMethods, this.estDetails.shippingMethodId),
            additionalFeeType: this.additionalFees?.find((af) => af.id == this.estDetails?.additionalFeesId),
            additionalFee: this.estDetails?.additionalRate,
            opportunity: opportunity,
            shippingChargeAmount: (Number(this.estDetails?.shippingChargeAmount ?? 0) * this.savedCurrencyExchangeRate).toFixed(this.fractionDigits),
        });
        this.enableDiableAdditionalDiscountRateField();
        this.setContentInEditor(this.estDetails.estimateNotes && this.estDetails.estimateNotes.length > 0 ? this.estDetails.estimateNotes[this.estDetails.estimateNotes.length - 1].note.comment : "");
    }
    setContentInEditor(text: any) {
        setTimeout(() => {
            const _quill = this.editor?.getQuill();
            const editorContainer = _quill.root;
            this.renderer.setProperty(editorContainer, "innerHTML", text);
        });
    }

    prepareProductsListToView(): void {
        this.allProductsData = (this.estDetails?.estimateProducts || []).map((estProduct) => {
            /** Bundle Products */
            const bundleDetails: IBundleProductList[] = (estProduct?.estimateBundleDetail || []).map((bundle) => {
                /** kit under Kit Products */
                const kitDetails: IBundleProductList[] = (bundle?.childEstimateBundleDetail || []).map((kp) => {
                    const kunit = kp.product.productUOM.find((uom) => uom.unitOfMeasureId == kp.productUOMId);
                    const kitDiscountType = this.discountOptions?.find((option) => option.id == kp.discountId);
                    return {
                        id: this.type == DialogType.EDIT || this.type == DialogType.COPY ? kp.subProductId : 0,
                        uuid: uuidv4(),
                        rowId: kp.id,
                        typeId: kp.product.typeId,
                        itemNo: kp.product.itemNo,
                        hsnsac: kp?.product?.hsnsac,
                        description: kp.description || "",
                        uom: kp.product.productUOM,
                        unit: kunit,
                        availableQuantity: kp.availableQuantity,
                        ordQty: kp.quantity,
                        originalQty: kp.originalQty,
                        bundleQty: kp.quantity,
                        cost: Number(kp.product.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                        price: Number(kp.pricePerProduct) * this.savedCurrencyExchangeRate,
                        originalprice: Number(kp.product?.accountProductPriceTiers?.find((tier) => tier.tierId == kp.product?.selectedtierId)?.calculatedPricePerQty),
                        accountPriceTier: kp.product?.accountProductPriceTiers,
                        isCustom: kp.product?.isCustom,
                        discountTypeName: kp.product?.tierTypeName || "",
                        selectedTierId: kp.product?.selectedtierId,
                        currentVal: kp.quantity,
                        discountType: kitDiscountType,
                        taxType: kp.tax || "",
                        discount: kp.discountRate ?? 0,
                        discountAmount: Number(kp.discountAmount) * this.savedCurrencyExchangeRate,
                        taxAmount: Number(kp.taxRate) * this.savedCurrencyExchangeRate,
                        subTotal: Number(kp.totalAmount) * this.savedCurrencyExchangeRate,
                        baseSubTotal: Number(kp.subTotal) * this.savedCurrencyExchangeRate,
                        totalQuantity: kp.totalQty,
                        bundleDetailSubTax: kp.estimateBundleDetailSubTax || [],
                        productCategory: kp?.product?.productCategories || [],
                        parentBundleId: kp.parentBundleId,
                        isDuplicatedProduct: kp?.isCopied ?? false,
                        costPrice: Number(kp.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                        totalCostPrice: Number(kp.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                    };
                });

                const unit = bundle.product.productUOM.find((uom) => uom.unitOfMeasureId == bundle.productUOMId);
                const bundleDiscountType = this.discountOptions?.find((option) => option.id == bundle.discountId);
                return {
                    id: this.type == DialogType.EDIT || this.type == DialogType.COPY ? bundle.subProductId : 0,
                    uuid: uuidv4(),
                    rowId: bundle.id,
                    typeId: bundle.product.typeId,
                    itemNo: bundle.product.itemNo,
                    hsnsac: bundle?.product?.hsnsac,
                    description: bundle.description || "",
                    uom: bundle.product.productUOM,
                    unit: unit,
                    availableQuantity: bundle.availableQuantity,
                    ordQty: bundle.quantity,
                    originalQty: bundle.originalQty,
                    bundleQty: bundle.quantity,
                    cost: Number(bundle.product.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                    price: Number(bundle.pricePerProduct) * this.savedCurrencyExchangeRate,
                    originalprice: Number(bundle.product?.accountProductPriceTiers?.find((tier) => tier.tierId == bundle.product?.selectedtierId)?.calculatedPricePerQty),
                    accountPriceTier: bundle.product?.accountProductPriceTiers,
                    isCustom: bundle.product?.isCustom,
                    discountTypeName: bundle.product?.tierTypeName || "",
                    selectedTierId: bundle.product?.selectedtierId,
                    currentVal: bundle.quantity,
                    discountType: bundleDiscountType,
                    taxType: bundle.tax || "",
                    discount: bundle.discountRate ?? 0,
                    discountAmount: Number(bundle.discountAmount) * this.savedCurrencyExchangeRate,
                    taxAmount: Number(bundle.taxRate) * this.savedCurrencyExchangeRate,
                    subTotal: Number(bundle.totalAmount) * this.savedCurrencyExchangeRate,
                    baseSubTotal: Number(bundle.subTotal) * this.savedCurrencyExchangeRate,
                    totalQuantity: bundle.totalQty,
                    bundleDetailSubTax: bundle.estimateBundleDetailSubTax || [],
                    productCategory: bundle?.product?.productCategories || [],
                    bundleDetails: kitDetails,
                    isDuplicatedProduct: bundle?.isCopied ?? false,
                    additionalFeeType: this.additionalFees?.find((af) => af.id == bundle?.additionalFeesId),
                    additionalFee: bundle?.additionalRate ?? 0,
                    additionalFeeAmount: Number(bundle?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                    costPrice: Number(bundle.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                    totalCostPrice: Number(bundle.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
                };
            });

            /** Product */
            const uom = estProduct.product.productUOM.find((po) => po.unitOfMeasureId == estProduct.productUOMId);
            const productDiscountType = this.discountOptions?.find((option) => option.id == estProduct.discountId);
            const totalAvailableQuantity = estProduct.productWarehouseDetailDTO.reduce((total, warehouseDetail) => total + warehouseDetail.availQty, 0);
            return {
                id: DialogType.EDIT ? estProduct.productId : 0,
                uuid: uuidv4(),
                rowId: estProduct.id,
                fieldId: estProduct.id,
                itemNo: estProduct.product.itemNo,
                hsnsac: estProduct?.product?.hsnsac,
                description: estProduct.description || "",
                uom: estProduct.product.productUOM,
                unit: uom,
                availableQuantity: totalAvailableQuantity,
                ordQty: estProduct.quantity,
                cost: Number(estProduct.product.productPrice?.buyPrice ?? 0) * this.savedCurrencyExchangeRate,
                price: Number(estProduct.pricePerProduct) * this.savedCurrencyExchangeRate,
                originalprice: Number(estProduct.product?.accountProductPriceTiers?.find((tier) => tier.tierId == estProduct.product?.selectedtierId)?.calculatedPricePerQty),
                accountPriceTier: estProduct.product?.accountProductPriceTiers,
                isCustom: estProduct.product?.isCustom,
                discountTypeName: estProduct.product?.tierTypeName || "",
                selectedTierId: estProduct.product?.selectedtierId,
                typeId: estProduct.product.typeId,
                bundleDetails: bundleDetails,
                productBundleLink: estProduct.product.productBundleLink || [],
                discountType: productDiscountType,
                taxType: estProduct.tax || "",
                discount: estProduct.discountRate ?? 0,
                discountAmount: Number(estProduct.discountAmount) * this.savedCurrencyExchangeRate,
                taxAmount: Number(estProduct.taxRate) * this.savedCurrencyExchangeRate,
                subTotal: Number(estProduct.totalAmount) * this.savedCurrencyExchangeRate,
                baseSubTotal: Number(estProduct.subTotal) * this.savedCurrencyExchangeRate,
                totalQuantity: estProduct.totalQty,
                productSubTax: estProduct.estimateProductSubTax || [],
                productCategory: estProduct?.product?.productCategories || [],
                isDuplicatedProduct: estProduct?.isCopied ?? false,
                additionalFeeType: this.additionalFees?.find((af) => af.id == estProduct?.additionalFeesId),
                additionalFee: estProduct?.additionalRate,
                additionalFeeAmount: Number(estProduct?.additionalAmount ?? 0) * this.savedCurrencyExchangeRate,
                costPrice: Number(estProduct.costPrice ?? 0) * this.savedCurrencyExchangeRate,
                totalCostPrice: Number(estProduct.totalCostPrice ?? 0) * this.savedCurrencyExchangeRate,
            };
        });

        this.purchaseListTB = this.allProductsData;
        this.selectedProductsList = this.allProductsData;
        this.purchaseListTB.forEach((product) => {
            if (product.typeId == this.typeIds.BundleTypeId) {
                const totalSubTotal = product.bundleDetails?.reduce((acc, bundle) => acc + bundle.subTotal, 0) || 0;
                product.subTotal = totalSubTotal;
            }
        });
    }
    prepareCustomFieldsToView(): void {
        Object.keys(this.combinedCustomFields).forEach((key) => {
            const dataArr = this.combinedCustomFields[key];
            if (dataArr && dataArr.length > 0) {
                dataArr.forEach((element) => {
                    const filteredCustom = this.estDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                    if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                        element.value = filteredCustom.value;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                        element.value = this.datepipe.transform(filteredCustom.value, "MM/dd/yyyy");
                    } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                        element.customUploadedFiles = [];
                        filteredCustom.customeAttachement.forEach((el) => {
                            element.customUploadedFiles.push(el);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                        element.value = filteredCustom.ratingId;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                        element.value = filteredCustom.toggle;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                        element.value = filteredCustom.values;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                        element.value = filteredCustom.values.name;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el.name);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el);
                        });
                    }
                });
            }
        });
    }
    /** End Estimate Edit */

    /** Account and contact */

    filterActiveAccounts() {
        const acc = _.cloneDeep(this.allAccounts);
        this.allAccounts = acc.filter((a) => a.statusId == 1);
    }
    async onRowSelectAccountAddress(e) {
        this.displayAccountAddress = false;
        this.accountAddressInfo = JSON.parse(JSON.stringify(this.selectedAccountAddress));

        // contact
        if (this.accountAddressInfo && this.accountAddressInfo?.address && this.accountAddressInfo?.address?.attnContact) {
            this.billingAddressContact = this.accountAddressInfo?.address?.attnContact;
        } else {
            if (this.accountInfo && this.accountInfo.accountContacts) {
                this.accountInfo.accountContacts.forEach((e) => {
                    if (e.isPrimaryContact) {
                        this.billingAddressContact = e?.contact;
                    }
                });
            }
        }

        await this.getTaxByAddress(this.accountAddressInfo?.address?.countryId, this.accountAddressInfo?.address?.stateId);
        if (this.purchaseListTB && this.purchaseListTB?.length > 0) {
            this.purchaseListTB?.forEach((product) => {
                if (product) {
                    product.subTotal = 0;
                    product.baseSubTotal = 0;
                    if (product.bundleDetails && product.bundleDetails?.length > 0) {
                        product?.bundleDetails?.forEach((bundleProduct) => {
                            if (bundleProduct) {
                                bundleProduct.subTotal = 0;
                                bundleProduct.baseSubTotal = 0;
                            }
                        });
                    }
                }
            });
            this.onProductAddComplete(this.purchaseListTB);
        }
    }
    openContactSelectionModal(e) {
        if (e == ContactSelectionType.BILLING) {
            this.selectedContact = this.billingAddressContact;
        }
        this.contactSelectionModalType = e;
        this.displayContactSelectionModal = true;
    }
    onContactSelectionComplete(e) {
        this.displayContactSelectionModal = false;
        if (this.contactSelectionModalType == ContactSelectionType.BILLING) {
            this.billingAddressContact = e?.contact;
        }
    }
    onContactSelectionCancel() {
        this.contactSelectionModalType = "";
        this.displayContactSelectionModal = false;
    }

    async selectAccount(c) {
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.accHoldMsg = "";
        this.shippingAddressInfo = null;
        this.accountAddressInfo = null;
        if (this.type !== DialogType.COPY) {
            this.purchaseListTB = [];
        }
        this.appMainService.isShowSpinner("loadCMAccountsAddress");
        if (this.accountInfo?.id !== c.id) {
            this.accountAddressInfo = null;
        }
        this.accountInfo = await this.salesOrderService.getAccountDetailsById(c.id);
        this.getcurrencyExchangeRate();
        if (this.selectedOpportunity && this.selectedOpportunity.accountId) {
            this.accountInfo["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.["businessName"];
            this.estForm.controls["account"].patchValue(this.accountInfo);
        }
        this.appMainService.isHideSpinner("loadCMAccountsAddress");
        if (this.accountInfo?.accountCreditControlId == CreditControlEnum.Hold) {
            this.accHoldMsg = accHoldMsg;
            return;
        }
        if (this.type == DialogType.COPY) {
            this.onChangeAccountUpdateProducts();
        }

        // default billing address
        if (this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0) {
            const allBillAddress = this.accountInfo.accountAddresses.filter((a) => a.address?.addressTypeId == this.billingAddressType?.id);
            this.accountAddressInfo = allBillAddress ? allBillAddress.filter((b) => b.address?.isDefault == true)[0] : null;
            this.selectedAccountAddress = this.accountAddressInfo;
        }

        //billing contact
        if (this.accountAddressInfo) {
            if (this.accountAddressInfo.address && this.accountAddressInfo.address.attnContactId) {
                this.billingAddressContact = this.accountAddressInfo.address.attnContact;
            } else {
                if (this.accountInfo && this.accountInfo.accountContacts) {
                    this.accountInfo.accountContacts.forEach((e) => {
                        if (e.isPrimaryContact) {
                            this.billingAddressContact = e?.contact;
                        }
                    });
                }
            }
        }
        this.displayAccountAddress = this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0 && !this.accountAddressInfo ? true : false;
        await this.getTaxByAddress(this.accountAddressInfo?.address?.countryId, this.accountAddressInfo?.address?.stateId);

        // set payment term associated with account
        let defaultTerms;
        this.allPaymentTerms = [];
        if (this.accountInfo?.accountPaymentTerms) {
            this.accountInfo?.accountPaymentTerms?.forEach((e) => {
                if (this.type == DialogType.CREATE && e.statusId == Status.Active) {
                    this.allPaymentTerms.push(e.paymentTerm);
                } else if (this.type == DialogType.EDIT || this.type == DialogType.COPY) {
                    this.allPaymentTerms.push(e.paymentTerm);
                }
                if (e.isDefault && e.statusId == Status.Active) {
                    defaultTerms = e.paymentTerm;
                }
            });
        }
        if (defaultTerms) {
            this.estForm.controls["paymentTerm"].setValue(defaultTerms);
        }

        let defaultMethods;
        this.allPaymentMethods = [];
        if (this.accountInfo?.accountPaymentMethods) {
            this.accountInfo?.accountPaymentMethods?.forEach((e) => {
                if (this.type == DialogType.CREATE && e.statusId == Status.Active) {
                    this.allPaymentMethods.push(e.paymentMethod);
                } else if (this.type == DialogType.EDIT || this.type == DialogType.COPY) {
                    this.allPaymentMethods.push(e.paymentMethod);
                }
                if (e.isDefault && e.statusId == Status.Active) {
                    defaultMethods = e.paymentMethod;
                }
            });
        }
        if (defaultMethods) {
            this.estForm.controls["paymentMethod"].setValue(defaultMethods);
        }

        /** Shipping method */
        if (this.accountInfo?.accountShippingMethods && this.accountInfo?.accountShippingMethods?.length > 0) {
            let defaultShippingMethod = this.accountInfo?.accountShippingMethods?.find((s) => s.isDefault == true);
            if (defaultShippingMethod) {
                this.setShippingMethodFormValue(defaultShippingMethod?.shippingMethodId);
            }
        }

        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT) {
            this.calculateOrderTotal();
        }
    }
    onChangeAccountChannel() {
        this.estForm.controls["account"].setValue("");
        this.estForm.controls["paymentTerm"].setValue("");
        this.estForm.controls["paymentMethod"].setValue("");
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.shippingAddressInfo = null;
        this.accountAddressInfo = null;
        if (this.type !== DialogType.COPY) {
            this.purchaseListTB = [];
        }
        this.setDefaultShippingMethod();
        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT) {
            this.calculateOrderTotal();
        }
    }
    clearAccount(event) {
        this.estForm.controls["account"].setValue("");
        this.estForm.controls["paymentTerm"].setValue("");
        this.estForm.controls["paymentMethod"].setValue("");
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.shippingAddressInfo = null;
        this.accountAddressInfo = null;
        if (this.type !== DialogType.COPY) {
            this.purchaseListTB = [];
        }
        this.setDefaultShippingMethod();
        if (this.type == DialogType.CREATE || this.type == DialogType.EDIT) {
            this.calculateOrderTotal();
        }
    }
    filterAccount(event) {
        let query = event.query;
        query = event.query;
        const typeId = this.estForm.controls["accountChannel"].value?.id;

        this.appMainService.isShowSpinner("getAccountList");
        this.accountServiceN
            .getAccountsByNameWithHierarchy(typeId, query)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.allAccountsDD = this.accountFlatteningService.flattenAccounts(response);
                    } else {
                        this.allAccountsDD = [];
                    }
                    this.appMainService.isHideSpinner("getAccountList");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getAccountList");
                },
                complete: () => {
                    this.appMainService.isHideSpinner("getAccountList");
                },
            });
    }
    editAccountAddress() {
        this.displayAccountAddress = true;
    }

    onAddNewContact(data) {
        this.appMainService.isShowSpinner("onAddNewContact");
        from(this.salesOrderService.getAccountDetailsById(this.accountInfo?.id)).subscribe(
            (data) => {
                this.appMainService.isHideSpinner("onAddNewContact");
                this.accountInfo = data;
            },
            (error) => {
                this.appMainService.isHideSpinner("onAddNewContact");
                console.error("Error fetching account details", error);
            },
        );
    }

    onAccountViewClick(e) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = e?.id ?? 0;
        this.selectedAccountChannelId = this.estForm.controls.accountChannel.value?.id;
    }
    closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
        this.selectedAccountChannelId = 0;
    }
    async reloadResultAfterSave() {
        this.selectAccount({ id: this.selectedAccountId });
    }
    setShippingMethodFormValue(id: number) {
        if (this.accountInfo && this.accountInfo?.accountShippingMethods && this.accountInfo?.accountShippingMethods?.length > 0) {
            this.estForm.controls["shippingMethod"].setValue(this.utilityService.findShippingMethodById(this.shippingMethods, id));
        }
    }
    setDefaultShippingMethod() {
        if (this.shippingMethods && this.shippingMethods?.length > 0) {
            this.estForm.controls["shippingMethod"].setValue(this.shippingMethods.filter((sm) => sm.isDefault == true)[0]);
        }
    }

    /** End Account and contact */

    async getTaxByAddress(countryId: number, stateId: number) {
        const taxData: any = await this.utilityService.getTaxByCountryId(countryId);
        this.taxSettings = taxData?.taxSettings ?? null;
        this.allTaxRates = taxData?.allTaxRates ?? [];
        this.taxConfig = taxData?.taxConfig ?? null;
    }

    editShippingAddress() {
        this.displayShippingAddress = true;
    }

    /** Save and Update Estimate */
    saveEstimate() {
        const isValid = this.utilityService.checkvalidation(this.combinedCustomFields);
        const customattributeList = this.utilityService.getCustomAttributesForAddEdit(this.combinedCustomFields);
        if (this.orderTotal < 0) {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Total can not be negative...",
            });
        } else {
            if ((this.type == DialogType.CREATE && isValid) || (this.type == DialogType.COPY && isValid)) {
                this.addNewEstimate(customattributeList);
            } else if (this.type == DialogType.EDIT && isValid) {
                this.updateEstimate(customattributeList);
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Please fill up all required field...",
                });
            }
        }
    }
    addNewEstimate(customattributeList) {
        this.isDisabled = true;
        const estimateObj = this.prepareEstimateForAddEdit(customattributeList);
        this.appMainService.isShowSpinner("loadEstimate");
        this.salesOrderService
            .addEstimate(estimateObj, this.isBaseCurrency())
            .then(() => {
                this.appMainService.isHideSpinner("loadEstimate");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: this.type == DialogType.CREATE ? "Estimate saved successfully..." : "Estimate copied successfully...",
                });
                this.onListEstimate.emit();
                this.estimateDialogClose.emit(false);
            })
            .catch(() => {
                this.isDisabled = false;
                this.appMainService.isHideSpinner("loadEstimate");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }
    updateEstimate(customattributeList) {
        this.isDisabled = true;
        const estimateObj = this.prepareEstimateForAddEdit(customattributeList);
        this.appMainService.isShowSpinner("loadEstimate");
        this.salesOrderService
            .updateEstimate(estimateObj, this.isBaseCurrency())
            .then(() => {
                this.appMainService.isHideSpinner("loadEstimate");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Estimate updated successfully...",
                });
                this.estimateDialogClose.emit(false);
            })
            .catch(() => {
                this.isDisabled = false;
                this.appMainService.isHideSpinner("loadEstimate");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while updating data...",
                });
            });
    }

    prepareProductsSubtaxCode(taxes: any[], qty: number, price: number, product, bundleProduct?) {
        let estimateProductSubTaxes: IEstimateProductSubTax[] = [];
        const subTotal = product.typeId == TypeIds.BundleTypeId ? bundleProduct.baseSubTotal : product.baseSubTotal;
        taxes?.forEach((rate) => {
            let taxAmount = product.typeId == TypeIds.BundleTypeId ? this.calculateProductsTax(rate.taxRate, subTotal, bundleProduct) : this.calculateProductsTax(rate.taxRate, subTotal, product);
            
            // split footer tax 
            if(this.footerTaxEnabled && !this.templates?.labels_table[5]?.isChecked) {
                const productContribution = product.typeId == TypeIds.BundleTypeId ? Number(bundleProduct.subTotal) / Number(this.productsTotal) : Number(product.subTotal) / Number(this.productsTotal);
                const productTaxShare = Number(this.tax) * productContribution;
                const totalTaxRate = taxes?.reduce((sum, item) => sum + item.taxRate, 0);
                taxAmount = (Number(rate.taxRate) / Number(totalTaxRate)) * Number(productTaxShare);
            }
            
            const tax = this.type == DialogType.CREATE ? this.allTaxRates.find((tax) => tax.id == rate.id) : rate.taxId ? this.allTaxRates.find((tax) => tax.id == rate.taxId) : this.allTaxRates.find((tax) => tax.id == rate.id); // new product added while editing invoice
            const estimateProductSubTax: IEstimateProductSubTax = {
                id: this.type == DialogType.CREATE || this.type == DialogType.COPY ? 0 : product?.isDuplicatedProduct ? 0 : rate.taxId == rate.id ? 0 : rate.taxId ? rate.id : 0,
                createdSource: this.type == DialogType.EDIT ? rate.createdSource : this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.type == DialogType.EDIT ? rate.createdBy : this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.type == DialogType.EDIT ? rate.createdDate : this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                taxId: this.type == DialogType.EDIT || this.type == DialogType.COPY ? rate.taxId ? rate.taxId : tax?.id || 0 : tax?.id || 0,
                taxRate: rate.taxRate,
                taxAmount: taxAmount,
                taxName: tax?.name || "",
                taxFinancialId: tax?.financialAccountId || 0,
                ...(product.typeId != TypeIds.BundleTypeId && { estimateProductId: this.type == DialogType.CREATE || this.type == DialogType.COPY ? product?.id || 0 : product.rowId ? product.rowId : product?.id || 0 }),
                ...(product.typeId == TypeIds.BundleTypeId && { estimateBundleDetailId: this.type == DialogType.CREATE || this.type == DialogType.COPY ? bundleProduct?.id || 0 : bundleProduct.rowId ? bundleProduct.rowId : bundleProduct?.id || 0 }),
                statusId: Status.Active,
            };
            this.orderTotalTax += taxAmount;
            estimateProductSubTaxes.push(estimateProductSubTax);
        });
        return estimateProductSubTaxes;
    }

    prepareProductsListForAddEdit(): IEstimateProduct[] {
        return (this.purchaseListTB || []).map((product) => {
            const bundleItems: IEstimateBundleProduct[] = [];
            for (let e of product.bundleDetails) {
                const obj: IEstimateBundleProduct = {
                    id: this.type == DialogType.EDIT ? e.rowId || 0 : 0,
                    estimateproductId: this.type == DialogType.EDIT ? product.rowId : 0,
                    createdSource: this.type == DialogType.EDIT ? this.estDetails.createdSource : this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.type == DialogType.EDIT ? this.estDetails.createdBy : this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.type == DialogType.EDIT ? this.estDetails.createdDate : this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    description: e.description,
                    estimateId: this.type == DialogType.EDIT ? this.estDetails.id : 0,
                    productId: product.id,
                    subproductId: e.id,
                    parentProductId: 0,
                    parentBundleId: 0,
                    productUOMId: e?.unit?.unitOfMeasureId || 0,
                    availableQuantity: e.availabel,
                    quantity: e.ordQty,
                    pricePerProduct: e.price,
                    subTotal: e.baseSubTotal,
                    totalAmount: e.subTotal,
                    discountTypeId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked && e.discountType ? e.discountType?.discountBy : this.estForm?.controls["discountType"]?.value?.discountBy || 0,
                    discountType: "",
                    discountAmount: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? e.discountAmount : this.utilityService.calculateDiscountPerProduct(e.subTotal, this.sumTotal, this.discount),
                    discountFinancialId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discountType?.id ? e?.discountType?.incomeAccount : 0) : (this.estForm.controls["discountType"]?.value?.incomeAccount ?? 0),
                    discountId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discountType?.id ? e.discountType?.id : 0) : (this.estForm.controls["discountType"]?.value?.id ?? 0),
                    discountName: "",
                    discountRate: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? (e.discount ?? 0) : (this.estForm.controls["discountValue"]?.value ?? 0),
                    additionalFeesId: this.templates?.labels_table[10]?.isChecked ? (e?.additionalFeeType?.id ?? 0) : 0,
                    additionalRate: this.templates?.labels_table[10]?.isChecked ? (e?.additionalFee ?? 0) : 0,
                    additionalAmount: this.templates?.labels_table[10]?.isChecked ? (e?.additionalFeeAmount ?? 0) : 0,
                    additionalFeesFinancialId: this.templates?.labels_table[10]?.isChecked ? (e?.additionalFeeType?.incomeAccount ?? 0) : 0,
                    taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.id : 0,
                    taxAmount: e.taxAmount,
                    taxRate: e.taxAmount,
                    taxName: "",
                    taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.typeId : 0,
                    taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && e.taxType ? e.taxType.financialAccountId : 0,
                    statusId: Status.Active,
                    estimateSerialNumber: null,
                    estimateBundleProductSerialDetail: null,
                    binId: 0,
                    totalQty: e.totalQuantity,
                    estimateBundleDetailSubTax: product.typeId == TypeIds.KitTypeId ? this.prepareProductsSubtaxCode(e.bundleDetailSubTax, product.ordQty, product.price, product, e) : this.prepareProductsSubtaxCode(e.bundleDetailSubTax, e.ordQty, e.price, product, e),
                    isCopied: e.isDuplicatedProduct ?? false,
                    costPrice: e.costPrice ?? 0,
                    totalCostPrice: e.totalCostPrice ?? 0,
                };
                bundleItems.push(obj);
                //kit under kit
                for (let kp of e.bundleDetails) {
                    const obj: IEstimateBundleProduct = {
                        id: this.type == DialogType.EDIT ? kp.rowId || 0 : 0,
                        estimateproductId: this.type == DialogType.EDIT ? product.rowId : 0,
                        createdSource: this.type == DialogType.EDIT ? this.estDetails.createdSource : this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.type == DialogType.EDIT ? this.estDetails.createdBy : this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: this.type == DialogType.EDIT ? this.estDetails.createdDate : this.app._saveDateTimeWithZone(new Date()),
                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                        description: kp.description,
                        estimateId: this.type == DialogType.EDIT ? this.estDetails.id : 0,
                        productId: product.id,
                        subproductId: kp.id,
                        parentProductId: e.id,
                        parentBundleId: this.type == DialogType.CREATE ? 0 : kp.parentBundleId,
                        productUOMId: kp?.unit?.unitOfMeasureId || 0,
                        availableQuantity: kp.availabel,
                        quantity: kp.ordQty,
                        pricePerProduct: kp.price,
                        subTotal: kp.baseSubTotal,
                        totalAmount: kp.subTotal,
                        discountTypeId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked && kp.discountType ? kp.discountType.discountBy : this.estForm?.controls["discountType"]?.value?.discountBy || 0,
                        discountType: "",
                        discountAmount: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? kp.discountAmount : this.utilityService.calculateDiscountPerProduct(kp.subTotal, this.sumTotal, this.discount),
                        discountFinancialId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discountType?.id ? kp.discountType?.incomeAccount : 0) : (this.estForm.controls["discountType"]?.value?.incomeAccount ?? 0),
                        discountId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discountType?.id ? kp.discountType?.id : 0) : (this.estForm.controls["discountType"]?.value?.id ?? 0),
                        discountName: "",
                        discountRate: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? (kp.discount ?? 0) : (this.estForm.controls["discountValue"]?.value ?? 0),
                        additionalFeesId: this.templates?.labels_table[10]?.isChecked ? (kp?.additionalFeeType?.id ?? 0) : 0,
                        additionalRate: this.templates?.labels_table[10]?.isChecked ? (kp?.additionalFee ?? 0) : 0,
                        additionalAmount: this.templates?.labels_table[10]?.isChecked ? (kp?.additionalFeeAmount ?? 0) : 0,
                        additionalFeesFinancialId: this.templates?.labels_table[10]?.isChecked ? (kp?.additionalFeeType?.incomeAccount ?? 0) : 0,
                        taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.id : 0,
                        taxAmount: kp.taxAmount,
                        taxRate: kp.taxAmount,
                        taxName: "",
                        taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.typeId : 0,
                        taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && kp.taxType ? kp.taxType.financialAccountId : 0,
                        statusId: Status.Active,
                        estimateSerialNumber: null,
                        estimateBundleProductSerialDetail: null,
                        binId: 0,
                        totalQty: kp.totalQuantity,
                        estimateBundleDetailSubTax: product.typeId == TypeIds.KitTypeId ? this.prepareProductsSubtaxCode(kp.bundleDetailSubTax, e.ordQty, e.price, e, kp) : this.prepareProductsSubtaxCode(kp.bundleDetailSubTax, kp.ordQty, kp.price, e, kp),
                        isCopied: kp.isDuplicatedProduct ?? false,
                        costPrice: kp.costPrice ?? 0,
                        totalCostPrice: kp.totalCostPrice ?? 0,
                    };
                    bundleItems.push(obj);
                }
            }
            const total = bundleItems.reduce((acc, e) => acc + Number(e.totalAmount), 0);
            const totalOfBaseSubTotal = bundleItems.reduce((acc, e) => acc + Number(e.subTotal), 0);
            const productTotalAmount = product.typeId == TypeIds.BundleTypeId ? total : product.subTotal;
            const productTotalOfBaseSubTotal = product.typeId == TypeIds.BundleTypeId ? totalOfBaseSubTotal : product.baseSubTotal;
            const obj: IEstimateProduct = {
                id: this.type == DialogType.EDIT ? product?.fieldId || 0 : 0,
                createdSource: this.type == DialogType.EDIT ? this.estDetails.createdSource : this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.type == DialogType.EDIT ? this.estDetails.createdBy : this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.type == DialogType.EDIT ? this.estDetails.createdDate : this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                description: product.description,
                estimateId: this.type == DialogType.EDIT ? this.estDetails.id : 0,
                productId: product.id,
                productUOMId: product?.unit?.unitOfMeasureId || 0,
                quantity: product.ordQty,
                quantityInStock: product.qoh,
                pricePerProduct: product.price,
                costPrice: product.costPrice ?? 0,
                totalCostPrice: product.totalCostPrice ?? 0,
                subTotal: productTotalOfBaseSubTotal,
                totalAmount: productTotalAmount,
                statusId: Status.Active,
                estimateBundleDetail: bundleItems.length > 0 ? bundleItems : [],
                discountTypeId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType ? product.discountType?.discountBy : this.estForm?.controls["discountType"]?.value?.discountBy || 0,
                discountType: "",
                discountAmount: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? product.discountAmount : this.utilityService.calculateDiscountPerProduct(productTotalAmount, this.sumTotal, this.discount),
                discountFinancialId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked && product.discountType?.id ? (product.discountType?.incomeAccount ?? 0) : (this.estForm.controls["discountType"]?.value?.incomeAccount ?? 0),
                discountId: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discountType?.id ? product.discountType?.id : 0) : (this.estForm.controls["discountType"]?.value?.id ?? 0),
                discountName: "",
                discountRate: this.discountEnabled && this.templates?.labels_table[6]?.isChecked ? (product.discount ?? 0) : (this.estForm.controls["discountValue"]?.value ?? 0),
                additionalFeesId: this.templates?.labels_table[10]?.isChecked ? (product?.additionalFeeType?.id ?? 0) : 0,
                additionalRate: this.templates?.labels_table[10]?.isChecked ? (product?.additionalFee ?? 0) : 0,
                additionalAmount: this.templates?.labels_table[10]?.isChecked ? (product?.additionalFeeAmount ?? 0) : 0,
                additionalFeesFinancialId: this.templates?.labels_table[10]?.isChecked ? (product?.additionalFeeType?.incomeAccount ?? 0) : 0,
                taxId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.id : 0,
                taxAmount: product.taxAmount,
                taxRate: product.taxAmount,
                taxName: "",
                taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.typeId : 0,
                taxFinancialId: this.footerTaxEnabled && this.templates?.labels_table[5]?.isChecked && product.taxType ? product.taxType.financialAccountId : 0,
                totalQty: product.totalQuantity,
                estimateProductSubTax: product.typeId !== TypeIds.BundleTypeId ? this.prepareProductsSubtaxCode(product.productSubTax, product.ordQty, product.price, product) : [],
                isCopied: product.isDuplicatedProduct ?? false,
            };
            return obj;
        });
    }

    prepareAdditionalDiscountsForNewEstimate(): IEstimateAddDiscount[] {
        if (this.estForm?.controls?.additionalDiscountTypeName?.value?.id && this.estForm?.controls?.additionalDiscountRate?.value > 0) {
            const additionalDiscount: IEstimateAddDiscount = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                estimateId: 0,
                discountId: this.estForm?.controls?.additionalDiscountTypeName?.value?.id ?? 0,
                discountTypeId: this.estForm?.controls?.additionalDiscountTypeName?.value?.type?.id ?? 0,
                discountRate: this.estForm?.controls?.additionalDiscountRate?.value ?? 0,
                discountAmount: Number(this.additionalDiscountAmount),
                statusId: Status.Active,
            };
            return [additionalDiscount];
        }
        return [];
    }
    prepareAdditionalDiscountsForUpdateEstimate(): IEstimateAddDiscount[] {
        if (this.estForm?.controls?.additionalDiscountTypeName?.value?.id && this.estForm?.controls?.additionalDiscountRate?.value > 0) {
            let addDiscount = this.estDetails?.estimateAddDiscount && this.estDetails.estimateAddDiscount.length > 0 ? this.estDetails.estimateAddDiscount[0] : null;
            const additionalDiscount: IEstimateAddDiscount = {
                id: addDiscount ? addDiscount.id : 0,
                createdSource: addDiscount ? addDiscount.createdSource : this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: addDiscount ? addDiscount.createdBy : this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: addDiscount ? addDiscount.createdDate : this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                estimateId: addDiscount ? addDiscount.estimateId : 0,
                discountId: this.estForm?.controls?.additionalDiscountTypeName?.value?.id ?? 0,
                discountTypeId: this.estForm?.controls?.additionalDiscountTypeName?.value?.type?.id ?? 0,
                discountRate: this.estForm?.controls?.additionalDiscountRate?.value ?? 0,
                discountAmount: Number(this.additionalDiscountAmount),
                statusId: Status.Active,
            };
            return [additionalDiscount];
        }
        return [];
    }
    prepareEstimateForAddEdit(customattributeList): IEstimate {
        const products = this.prepareProductsListForAddEdit();
        const estimateObj: IEstimate = {
            id: this.type == DialogType.EDIT ? this.estDetails.id : 0,
            createdSource: this.type == DialogType.EDIT ? this.estDetails.createdSource : this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.type == DialogType.EDIT ? this.estDetails.createdBy : this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.type == DialogType.EDIT ? this.estDetails.createdDate : this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            number: this.type == DialogType.EDIT ? this.estDetails.number : "",
            name: "",
            description: "",
            estimateObjectId: this.estimateObjectId,
            contactId: this.billingAddressContact ? this.billingAddressContact.id : 0,
            businessName: this.accountInfo?.businessName,
            userId: this.estForm?.controls["salesRep"]?.value?.id || 0,
            organizationId: this.app.companyId,
            accountId: this.estForm.controls["account"].value.id || 0,
            estimateDate: this.app._saveDateTimeWithZone(this.estForm.controls["estimateDate"].value),
            expiryDate: this.app._saveDateTimeWithZone(this.estForm.controls["expiryDate"].value),
            warehouseId: this.estForm.controls["location"].value?.id,
            totalAmount: this.sumTotal,

            discountTypeId: this.discountEnabled && this.templates?.labels_footer[1]?.isChecked && this.estForm.controls["discountType"].value ? (this.estForm.controls["discountType"]?.value?.discountBy ?? 0) : 0,
            discountType: "",
            discountAmount: this.discountEnabled && this.templates?.labels_footer[1]?.isChecked ? this.discount : 0,
            discountFinancialId: this.discountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.estForm.controls["discountType"]?.value?.incomeAccount ?? 0) : 0,
            discountId: this.discountEnabled && this.templates?.labels_footer[1]?.isChecked ? (this.estForm.controls["discountType"]?.value?.id ?? 0) : 0,
            discountName: "",
            discountRate: this.discountEnabled && this.templates?.labels_table[1]?.isChecked ? (this.estForm.controls["discountValue"]?.value ?? 0) : 0,
            additionalFeesId: this.templates?.labels_footer[6]?.isChecked ? (this.estForm?.controls["additionalFeeType"]?.value?.id ?? 0) : 0,
            additionalRate: this.templates?.labels_footer[6]?.isChecked ? (this.estForm?.controls["additionalFee"]?.value ?? 0) : 0,
            additionalAmount: this.templates?.labels_footer[6]?.isChecked ? this.totalAdditionalFee : 0,
            additionalFeesFinancialId: this.templates?.labels_footer[6]?.isChecked ? (this.estForm?.controls["additionalFeeType"]?.value?.incomeAccount ?? 0) : 0,
            taxId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.id || 0 : 0,
            taxAmount: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.tax : 0,
            taxName: "",
            taxRateTypeId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.typeId || 0 : 0,
            taxFinancialId: this.footerTaxEnabled && this.templates?.labels_footer[2]?.isChecked ? this.allTaxRates?.[0]?.financialAccountId || 0 : 0,
            referenceNumber: this.estForm.controls["referenceNumber"].value,
            shippingChargeAmount: this.estForm?.controls["shippingChargeAmount"]?.value || 0,
            netAmount: this.orderTotal,
            estimateStageId: 0,
            estimateStatusId: this.estForm?.controls["estimateStatusId"]?.value?.id,
            paymentMethodId: this.estForm?.controls["paymentMethod"]?.value?.id || 0,
            paymentTermId: this.estForm?.controls["paymentTerm"]?.value?.id || 0,
            shippingMethodId: this.estForm?.controls?.shippingMethod?.value?.id ?? 0,
            shippingFinancialId: this.estForm?.controls?.shippingMethod?.value?.financialAccountId ?? 0,
            shippingTermId: this.estForm?.controls["shippingTerm"]?.value?.id || 0,
            sourceId: 0,
            isEstimateApproved: false,
            typeId: 0,
            groupId: 0,
            statusId: this.estForm.controls["statusId"].value ? 1 : 2,
            emailId: 0,
            billingAddressId: this.accountAddressInfo && this.accountAddressInfo?.addressId ? this.accountAddressInfo?.addressId : "",
            termsConditions: "",
            estimateNotes: this.prepareEstimateNotes(),
            estimateAudits: this.prepareEstimateAudits(),
            estimateProducts: products,
            customAttributeValues: this.type == DialogType.EDIT ? this.setExistingCustomAttributes(customattributeList) : this.setCustomAttributes(customattributeList),
            configJson: "",
            channelId: this.estForm.controls.accountChannel.value?.id || 0,
            additionalDiscount: Number(this.additionalDiscountAmount),
            estimateAddDiscount: this.type == DialogType.COPY || this.type == DialogType.CREATE ? this.prepareAdditionalDiscountsForNewEstimate() : this.prepareAdditionalDiscountsForUpdateEstimate(),
            approvalStatusId: this.type == DialogType.EDIT ? this.estDetails.approvalStatusId : 0,
            opportunityId: this.sOpportunity?.id ?? 0,
            currencyUnitId: this.accountInfo?.currencyId ?? 0,
            exchangeRate: this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate,
            isProductLevelDiscount: this.templates?.labels_table[6]?.isChecked ?? false
        };
        return estimateObj;
    }

    /** Estimate Note and Audits */
    prepareNote(comment: string) {
        const note: INote = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            comment: comment,
            isImportant: true,
            organizationId: this.app.companyId,
            description: "",
            statusId: Status.Active,
            status: null,
            isValid: true,
            validFromDate: this.app._saveDateTimeWithZone(new Date()),
            validToDate: this.app._saveDateTimeWithZone(new Date()),
            noteComments: null,
            noteAttachments: null,
            createdByName: "",
        };
        return note;
    }
    prepareEstimateNotes() {
        let estimatesNotes: IEstimateNote[] = [];
        if (this.estForm.controls["memo"].value && this.estForm.controls["memo"].value != "") {
            let estimatesNote: IEstimateNote = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                estimateId: 0,
                userId: this.app.user.userId,
                description: "",
                noteId: 0,
                note: this.prepareNote(this.estForm.controls["memo"].value),
                estimateStageId: 0,
                estimateStatusId: this.estForm.controls["estimateStatusId"].value.id,
                attachmentId: 0,
            };
            estimatesNotes.push(estimatesNote);
        }
        return estimatesNotes;
    }
    prepareEstimateAudits() {
        let estimatesAudits: IEstimateAudit[] = [];
        if (this.estForm.controls["vendorMessage"].value && this.estForm.controls["vendorMessage"].value != "") {
            let estimatesAudit: IEstimateAudit = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                estimateId: 0,
                noteId: 0,
                note: this.prepareNote(this.estForm.controls["vendorMessage"].value),
                description: "",
            };
            estimatesAudits.push(estimatesAudit);
        }
        return estimatesAudits;
    }
    /** End Estimate Note and Audits */

    /** Custom fields */
    setExistingCustomAttributes(value) {
        const custom: any = [];
        value?.forEach((element) => {
            const customEach = {
                id: this.estDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0] ? this.estDetails.customAttributeValues.filter((custom) => custom.customAttributeId == element.id)[0]?.id : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.userId,
                updatedBy: this.app.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                objectId: this.app.preLoadedObjects.find((obj) => obj.name == "Orders").id,
                objectValue: this.estDetails.id,
                customAttributeId: element.id,
                customAttribute: this.modifyCustumAttributes(element),
                value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" || element.formControl?.name == "Number" ? element.value : null,
                statusId: Status.Active,
                status: null,
                values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
            };
            custom.push(customEach);
        });
        return custom;
    }
    setCustomAttributes(value) {
        const custom: any[] = [];
        value?.forEach((element) => {
            const customEach = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.userId,
                updatedBy: this.app.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                objectId: this.app.preLoadedObjects.find((obj) => obj.name == "Orders").id,
                objectValue: 0,
                customAttributeId: element.id,
                customAttribute: this.modifyCustumAttributes(element),
                value: element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" || element.formControl?.name == "Number" ? element.value : null,
                statusId: Status.Active,
                status: null,
                values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
                multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
                ratingId: element.formControl?.name == "Rating" ? element.value : 0,
                toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
                customeAttachement: element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture" ? element.customUploadedFiles : null,
            };
            custom.push(customEach);
        });
        return custom;
    }
    modifyCustumAttributes(data) {
        if (data.pickListValues) {
            data.pickListValues = JSON.stringify(data.pickListValues);
        }
        return data;
    }
    /** End Custom Fields */

    /** End Save and Update Estimate */

    confirmVoid() {
        this.confirmationService.confirm({
            message: "Do you want to void this Estimate?",
            header: "Void Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                if (this.statementMessege) {
                    this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
                } else {
                    this.displayEstimateAdd = false;
                    this.onVoidEstimate.emit(this.estDetails.id);
                }
            },
            reject: () => {},
        });
    }

    openWarehouseList(c) {
        this.displayOpenWarehouseList = true;
        this.warehouseLists = c.warehouseList;
        this.selectedWarehouseList = [];
    }

    addWarehouse() {
        this.displayOpenWarehouseList = false;
        this.purchaseListTB.forEach((p) => {
            const filteredProduct = this.selectedWarehouseList.filter((s) => s.productId == p.id)[0];
            if (filteredProduct && p.id == filteredProduct.productId) {
                let qoh = 0;
                let avail = 0;
                let codes = "";
                this.selectedWarehouseList.forEach((e, index) => {
                    avail += e.availQty;
                    qoh += e.qtyOnHand;
                    codes += e.warehouseName + ",";
                });
                p.selectedWarehouseList = this.selectedWarehouseList;
                p.selectedWarehouseCode = codes.slice(0, codes.length - 1);
                p.totalAvailInSelectedWareHouse = avail;
                p.totalQohInSelectedWareHouse = qoh;
            }
        });
    }

    setCheckBoxValue(value) {
        const checkBox: any[] = [];
        value.forEach((element) => {
            const val = { name: element };
            checkBox.push(val);
        });
        return checkBox;
    }

    onCustomUpload(files: File[], field) {
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(file, 4, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {
                        let attachment = {
                            name: name,
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                        };
                        field.customUploadedFiles.push(attachment);
                    });
                }
            }
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
    }

    /** Products add and remove  */
    openProductsDialog() {
        this.moduleName = SOChannel.ESTIMATES;
        this.displayProductSelectionModal = true;
        this.selectedProductsList = this.purchaseListTB;
        this.selectedLocationId = this.estForm?.controls?.location?.value?.id || 0;
    }
    openProductsDialogForBundle(bundle) {
        this.moduleName = "Bundle";
        this.selectedBundle = bundle;
        this.displayProductSelectionModal = true;
        this.selectedProductsList = bundle.bundleDetails;
        this.selectedLocationId = this.estForm?.controls?.location?.value?.id || 0;
    }
    onCancelClicked(e) {
        this.displayProductSelectionModal = false;
    }
    onProductAddComplete(event) {
        this.displayProductSelectionModal = false;
        const updatedProducts = this.utilityService.convertProductPriceByExchangeRate(event, this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
        this.purchaseListTB = this.productCalculationUtilityService.onProductSelectionComplete(this.moduleName, this.purchaseListTB, this.selectedBundle, updatedProducts, this.allTaxRates, this.footerTaxEnabled, this.isVisibleRowTax, this.accountAddressInfo?.address?.zipCode, this.accountAddressInfo?.address?.stateId, this.taxSettings, this.taxConfig);
        this.reCalculateProductsTotal("productAdd");

        if (this.purchaseListTB && this.purchaseListTB.length) {
            this.estForm.controls.location.disable();
        }
        this.calculateOrderTotal();
    }
    onChangeCurrencyRecalculateAmount() {
        this.purchaseListTB = this.utilityService.reConvertProductPriceByExchangeRate(this.purchaseListTB, this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate, this.previousCurrencyExchangeRate);
        this.reCalculateProductsTotal();

        if (this.purchaseListTB && this.purchaseListTB.length) {
            this.estForm.controls.location.disable();
        }
        this.calculateOrderTotal();
        this.previousCurrencyExchangeRate = this.currencyExchangeRate;
    }
    onProductSearchComplete(e) {
        const updatedProducts = this.utilityService.convertProductPriceByExchangeRate(this.utilityService.setTotalCostPrice(e), this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
        const data = {
            channelName: SOChannel.ESTIMATES,
            products: this.purchaseListTB,
            newProducts: updatedProducts,
            allTaxRates: this.allTaxRates,
            isVisibleRowTax: this.isVisibleRowTax,
            taxEnabled: this.footerTaxEnabled,
            stateId: this.accountAddressInfo?.address?.stateId,
            zipCode: this.accountAddressInfo?.address?.zipCode,
            taxSettings: this.taxSettings,
            taxConfig: this.taxConfig,
            allDiscounts: this.discountOptions,
            discountTypeId: this.estForm.controls["discountType"]?.value?.id,
        };
        this.purchaseListTB = this.productCalculationUtilityService.onProductSearchCompleteByBarcode(data);
        this.sumTotal = 0;
        for (let s of this.purchaseListTB) {
            this.sumTotal = this.sumTotal + s.baseSubTotal;
            s.currentVal = s.availabel;
        }
        if (this.purchaseListTB && this.purchaseListTB.length) {
            this.estForm.controls.location.disable();
        }
        this.calculateOrderTotal();
    }
    reCalculateProductsTotal(type?) {
        const allTaxes = this.purchaseListTB?.flatMap((product) => {
            return product.typeId === this.typeIds.BundleTypeId
                ? product.bundleDetails.flatMap((bundle) => bundle.bundleDetailSubTax || [])
                : product.productSubTax || [];
        });
        const uniqueTaxIds = Array.from(
            new Set(
                allTaxes?.map((tax) => tax.taxId || tax.id)
            )
        );
        const taxRates = this.allTaxRates.filter((taxRate) =>
            uniqueTaxIds.includes(taxRate.id)
        );
        const filteredTaxRates = taxRates?.map((taxRate) => ({ ...taxRate, taxId: taxRate.taxId || taxRate.id }));
        this.sumTotal = 0;
        this.purchaseListTB?.forEach((s) => {
            if (s.typeId == TypeIds.BundleTypeId) {
                s?.bundleDetails?.forEach((bundleProduct) => {
                    if (!bundleProduct?.isManualTaxApplied && this.footerTaxEnabled) {
                        const subTaxes = this.utilityService.getProductsApplicableSubTaxes(bundleProduct, this.allTaxRates, this.accountAddressInfo?.address?.zipCode, this.accountAddressInfo?.address?.stateId, this.taxSettings, this.taxConfig);
                        bundleProduct.bundleDetailSubTax = subTaxes;

                        if(type && type == "productAdd"){
                            bundleProduct.bundleDetailSubTax = filteredTaxRates;
                        }
                    }
                    this.onChangeBundleProductTaxOrDiscount(s, bundleProduct, type ? type : "qty");
                });
            } else {
                if (!s?.isManualTaxApplied && this.footerTaxEnabled) {
                    const subTaxes = this.utilityService.getProductsApplicableSubTaxes(s, this.allTaxRates, this.accountAddressInfo?.address?.zipCode, this.accountAddressInfo?.address?.stateId, this.taxSettings, this.taxConfig);
                    if(type != "tax") {
                        s.productSubTax = subTaxes;
                    }

                    if(type && type == "productAdd"){
                        s.productSubTax = filteredTaxRates;
                    }
                }
                this.onChangeProductTaxOrDiscount(s, type ? type : "qty");
            }
            this.sumTotal = this.sumTotal + s.baseSubTotal;
            s.currentVal = s.availabel;
        });
    }
    removeProduct(i) {
        this.purchaseListTB.splice(i, 1);
        if (this.type == DialogType.CREATE && this.purchaseListTB && this.purchaseListTB.length == 0) {
            this.estForm.controls.location.enable();
        }
        this.calculateOrderTotal();
    }
    removeBundleProduct(bundle, i) {
        this.purchaseListTB.forEach((e) => {
            if (e.id == bundle.id) {
                e.bundleDetails.splice(i, 1);
                if (e.typeId == this.typeIds.BundleTypeId) {
                    let total = 0;
                    e.bundleDetails.forEach((ib) => {
                        total += ib.subTotal;
                    });
                    e.price = total;
                    e.subTotal = total;
                } else if (e.typeId == this.typeIds.KitTypeId) {
                    let kitQty = 0;
                    let kitCount = 0;
                    let count = 0;
                    e.bundleDetails?.forEach((element) => {
                        if (element.typeId == TypeIds.InventoryTypeId) {
                            if (count == 0) {
                                kitQty = Math.floor(element.availabel / (element.ordQty * (element?.unit?.uomDetail?.value || 1)));
                                kitCount = isNaN(kitCount) ? 0 : kitCount;
                                kitCount = kitQty < 0 ? 0 : kitQty;
                                count++;
                            } else if (count > 0) {
                                kitQty = Math.floor(element.availabel / (element.ordQty * (element?.unit?.uomDetail?.value || 1)));
                                kitCount = isNaN(kitCount) ? 0 : kitCount;
                                kitCount = kitQty <= kitCount && kitQty >= 0 ? kitQty : kitCount;
                                count++;
                            }
                        }
                    });
                    e.totalAvailInSelectedWareHouse = kitCount;
                    e.availabel = kitCount;
                }
            }
        });
        this.calculateOrderTotal();
    }
    /** End Product add and remove  */

    onChangeAccountUpdateProducts() {
        const selectedLocationId = this.estForm?.controls?.location?.value?.id;
        const productIds = this.purchaseListTB.map((prod) => prod.id).join(",");
        this.appMainService.isShowSpinner("loadProducts");
        this.productsService
            .getProductList(this.accountInfo.id, productIds, selectedLocationId)
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                map((resp) => this.productDataService.prepareProductsList(resp)),
                tap((products) => this.updateProductQuantities(products)),
                finalize(() => this.appMainService.isHideSpinner("loadProducts")),
            )
            .subscribe(
                () => {},
                () => {},
            );
    }
    updateProductQuantities(products) {
        this.purchaseListTB?.forEach((product) => {
            const purchaseProduct = products?.find((p) => p.id === product.id);
            if (purchaseProduct) {
                product.price = purchaseProduct.price ?? 0;
                product.subTotal = 0;
                product.baseSubTotal = 0;
                if (product.bundleDetails && product.bundleDetails?.length > 0) {
                    product?.bundleDetails?.forEach((bundleProduct) => {
                        const bundleProductToUpdate = purchaseProduct?.bundleDetails?.find((bp) => bp.id === bundleProduct.id);
                        if (bundleProductToUpdate) {
                            bundleProductToUpdate.price = bundleProduct.price ?? 0;
                            bundleProductToUpdate.subTotal = 0;
                            bundleProductToUpdate.baseSubTotal = 0;
                        }
                    });
                }
            }
            this.calculateProductsSubTotal(product, product.ordQty, "discount");
        });
        this.calculateOrderTotal();
    }

    /** Copy Product */
    copyProduct() {
        const newProduct = _.cloneDeep(this.selectedProduct);
        if (this.type == DialogType.EDIT) {
            newProduct.uuid = uuidv4();
            newProduct.fieldId = 0;
            newProduct.rowId = 0;
            newProduct.isDuplicatedProduct = true;
            newProduct.description = `${newProduct.description} - add`;
            if (newProduct?.typeId == TypeIds.KitTypeId && newProduct.bundleDetails && newProduct.bundleDetails.length > 0) {
                newProduct.bundleDetails = newProduct.bundleDetails.map((bProduct) => ({ ...bProduct, uuid: uuidv4(), fieldId: 0, rowId: 0, isDuplicatedProduct: true }));
            }
        } else {
            newProduct.uuid = uuidv4();
            newProduct.isDuplicatedProduct = true;
            newProduct.description = `${newProduct.description} - add`;
            if (newProduct?.typeId == TypeIds.KitTypeId && newProduct.bundleDetails && newProduct.bundleDetails.length > 0) {
                newProduct.bundleDetails = newProduct.bundleDetails.map((bProduct) => ({ ...bProduct, isDuplicatedProduct: true }));
            }
        }
        this.purchaseListTB.push(newProduct);
        this.selectedProductsList = this.purchaseListTB;
        this.calculateOrderTotal();
    }

    /** Context Menu */
    prepareProductContextMenu(e: MouseEvent, cmProduct) {
        if (this.selectedProduct?.isDuplicatedProduct || this.selectedProduct?.typeId == TypeIds.BundleTypeId) {
            this.productconfigMenu = [];
            cmProduct?.hide();
        } else {
            this.productconfigMenu = [
                {
                    label: "Copy",
                    icon: "pi pi-copy",
                    visible: true,
                    command: () => {
                        this.copyProduct();
                    },
                },
            ];
            cmProduct?.show();
        }
    }

    onchangeAdditionalDiscountTypeName() {
        this.enableDiableAdditionalDiscountRateField();
        this.additionalDiscountRateTypes = [this.estForm?.controls?.additionalDiscountTypeName?.value];
        this.estForm.controls.additionalDiscountType.setValue(this.estForm?.controls?.additionalDiscountTypeName?.value ?? null);
        this.estForm.controls.additionalDiscountRate.setValue(this.estForm?.controls?.additionalDiscountTypeName?.value?.discountValue ?? 0);
        this.calculateOrderTotal();
    }
    enableDiableAdditionalDiscountRateField() {
        if (this.estForm?.controls?.additionalDiscountTypeName?.value?.description?.toLowerCase() != "manual") {
            this.estForm?.controls?.additionalDiscountRate?.disable();
        } else {
            this.estForm?.controls?.additionalDiscountRate?.enable();
        }
    }

    isClosingStatementDate(event: string) {
        this.statementMessege = event;
    }

    /** Order Total Calculation */

    calculateOrderTotal(type?: string) {
        if (type == "discounttype") {
            this.estForm?.controls["discountValue"]?.setValue(this.estForm?.controls["discountType"]?.value?.discountValue || 0);
        } else if (type == "totalAdditionalFeetype") {
            this.estForm?.controls["additionalFee"]?.setValue(this.estForm?.controls["additionalFeeType"]?.value?.discountValue || 0);
        }
        this.discount = 0;
        this.orderTotal = 0;
        this.sumTotal = 0;
        this.tax = 0;
        this.totalAdditionalFee = 0;
        this.additionalDiscountAmount = 0;
        this.productsTotal = 0;
        this.productsTotalAdditionalFee = 0;
        let totalAmount = this.calculateProductsTotal();

        // Step 1: Subtract Discount
        this.discount = this.calculateDiscount();
        if (this.discountEnabled) {
            totalAmount -= this.discount;
        }

        // Step 2: Add Tax
        this.tax = this.calculateTax(totalAmount);
        if (this.footerTaxEnabled) {
            totalAmount += this.tax;
        }

        // Step 3: Add Additional Fee
        this.totalAdditionalFee = this.calculateAdditionalFee(totalAmount);
        totalAmount += this.totalAdditionalFee;

        // Step 4: Subtract Additional Discount
        this.additionalDiscountAmount = this.calculateAdditionalDiscount(totalAmount);
        totalAmount = Number(totalAmount) - Number(this.additionalDiscountAmount);

        // Step 5: Add Shipping Charge
        const shipValue = this.estForm.controls["shippingChargeAmount"].value ? Number(this.estForm.controls["shippingChargeAmount"].value) : 0;
        this.orderTotal = totalAmount + shipValue;
    }
    private calculateProductsTotal() {
        for (let s of this.purchaseListTB) {
            if (s.typeId == TypeIds.BundleTypeId) {
                let bTotal = 0;
                s?.bundleDetails?.forEach((b) => {
                    bTotal += Number(b.subTotal);
                    this.productsTotalAdditionalFee += Number(b.additionalFeeAmount);
                });
                s.subTotal = bTotal;
            } else {
                this.productsTotalAdditionalFee += Number(s.additionalFeeAmount);
            }
            this.sumTotal += Number(s.baseSubTotal);
            this.productsTotal += Number(s.subTotal);
        }
        const totalAmount = this.sumTotal + this.productsTotalAdditionalFee;
        return totalAmount;
    }
    private calculateDiscount() {
        const disName = this.estForm?.controls["discountType"]?.value?.name || "";
        let disValue = this.estForm?.controls["discountValue"]?.value || 0;
        return this.utilityService.calculateOrderTotalDiscount(disName, disValue, this.sumTotal, this.purchaseListTB, this.isVisibleRowDiscount, this.discountEnabled, this.isVisibleFooterDiscount);
    }
    private calculateTax(totalAmount: number): number {
        return this.utilityService.calculateOrderTotalTax(this.purchaseListTB, totalAmount, this.isVisibleRowTax, this.footerTaxEnabled, this.isVisibleFooterTax, this.allTaxRates);
    }
    private calculateAdditionalFee(totalAmount: number): number {
        return this.utilityService.calculateOrderTotalAdditionalFee(this.estForm?.controls["additionalFeeType"]?.value?.type?.name, this.estForm?.controls["additionalFee"]?.value, totalAmount, this.purchaseListTB, this.templates?.labels_table[10]?.isChecked, this.templates?.labels_footer[6]?.isChecked);
    }
    private calculateAdditionalDiscount(totalAmount: number): Number {
        if (this.estForm?.controls?.additionalDiscountTypeName?.value?.type?.description == "%" || this.estForm?.controls?.additionalDiscountTypeName?.value?.type?.description == "Percentage") {
            if (Number(this.estForm.controls.additionalDiscountRate.value) > 100) {
                this.estForm.controls.additionalDiscountRate.setValue(100);
            }
        } else if (this.estForm?.controls?.additionalDiscountTypeName?.value?.type?.description == "$" || this.estForm?.controls?.additionalDiscountTypeName?.value?.type?.description == "Amount") {
            if (Number(this.estForm.controls.additionalDiscountRate.value) > Number(totalAmount)) {
                this.estForm.controls.additionalDiscountRate.setValue(totalAmount);
            }
        }
        if (this.estForm?.controls?.additionalDiscountTypeName?.value && this.estForm?.controls?.additionalDiscountType?.value) {
            if (this.estForm.controls.additionalDiscountType.value.type.description == "%" || this.estForm.controls.additionalDiscountType.value.type.description == "Percentage") {
                this.additionalDiscountAmount = this.estForm.controls.additionalDiscountRate.value > 0 ? totalAmount * (Number(this.estForm.controls.additionalDiscountRate.value) / 100) : this.additionalDiscountAmount;
            } else {
                this.additionalDiscountAmount = Number(this.estForm.controls.additionalDiscountRate.value);
            }
        }
        return this.additionalDiscountAmount;
    }

    /** End Order Total Calculation */

    calculateProductsSubTotal(item, qty, type) {
        if (type == "discounttype") {
            item.discount = item?.discountType?.discountValue ?? 0;
        } else if (type == "additionalFeeType") {
            item.additionalFee = item?.additionalFeeType?.discountValue ?? 0;
        } else if (type == "baseSubTotal") {
            const uomValue = item?.unit?.uomDetail?.value || 1;
            item.price = item.baseSubTotal / (Number(item.ordQty) * Number(uomValue));
        }else if(type == "price" && item.price == 0){
            item.discount = 0;
            item.additionalFee = 0;
            item.discountType = null;
            item.additionalFeeType = null;
        }

        /**
         * If type is bundle, then first calculate ordQty & totalQuantity of a product inside bundle.
         * then calculate subtotal of a product and total of bundle
         */
        if (item.typeId == TypeIds.BundleTypeId) {
            const data = {
                dialogType: this.type,
                allTaxRates: this.allTaxRates,
                channelName: SOChannel.ESTIMATES,
                aggregateDiscount: this.aggregateDiscount,
                isEnabledRowTax: this.isVisibleRowTax,
                taxEnabled: this.footerTaxEnabled,
                stateId: this.accountAddressInfo?.address?.stateId,
                zipCode: this.accountAddressInfo?.address?.zipCode,
                taxSettings: this.taxSettings,
                taxConfig: this.taxConfig,
                allDiscounts: this.discountOptions,
                isRowWiseAdditionalFeeEnabled: this.templates?.labels_table[10]?.isChecked ?? false,
                isRowWiseDiscountEnabled: this.templates?.labels_table[6]?.isChecked ?? false,
            };
            this.productCalculationUtilityService.calculateQtyAndBundleProductsSubTotal(item, qty, this.allTaxRates, this.soChannel.ESTIMATES, this.type, this.footerTaxEnabled, this.isVisibleRowTax, data);
            this.calculateOrderTotal();
        } else {
            this.onChangeProductTaxOrDiscount(item, type);
            this.calculateOrderTotal();
        }
    }
    onChangeProductTaxOrDiscount(product, type) {
        const uomValue = product?.unit?.uomDetail?.value || 1;
        product.totalQuantity = Number(product.ordQty) * Number(uomValue);
        product.totalCostPrice = Number(product.costPrice) * Number(product.totalQuantity);

        // Pricebook
        if (product.typeId != 4) {
            if ((type == "qty" || type == "uom") && product.accountPriceTier?.length > 0) {
                product.price = this.utilityService.applyPriceBook(this.aggregateDiscount, product, Number(product.ordQty) * Number(uomValue));
                product.price = product.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
            }
        }
        const data = {
            product: product,
            dialogType: this.type,
            allTaxRates: this.allTaxRates,
            channelName: SOChannel.ESTIMATES,
            aggregateDiscount: this.aggregateDiscount,
            isEnabledRowTax: this.isVisibleRowTax,
            taxEnabled: this.footerTaxEnabled,
            stateId: this.accountAddressInfo?.address?.stateId,
            zipCode: this.accountAddressInfo?.address?.zipCode,
            taxSettings: this.taxSettings,
            taxConfig: this.taxConfig,
            allDiscounts: this.discountOptions,
            discountTypeId: product?.discountType?.id ?? 0,
            isRowWiseAdditionalFeeEnabled: this.templates?.labels_table[10]?.isChecked ?? false,
            isRowWiseDiscountEnabled: this.templates?.labels_table[6]?.isChecked ?? false,
        };
        this.productCalculationUtilityService.calculateProductsSubTotal(data);
    }
    onChangeBundleProductTaxOrDiscount(bundle, product, type) {
        const data = {
            bundle: bundle,
            product: product,
            type: type,
            channelName: SOChannel.ESTIMATES,
            aggregateDiscount: this.aggregateDiscount,
            allTaxRates: this.allTaxRates,
            taxEnabled: this.footerTaxEnabled,
            isVisibleRowTax: this.isVisibleRowTax,
            stateId: this.accountAddressInfo?.address?.stateId,
            zipCode: this.accountAddressInfo?.address?.zipCode,
            taxSettings: this.taxSettings,
            taxConfig: this.taxConfig,
            allDiscounts: this.discountOptions,
            discountTypeId: product?.discountType?.id ?? 0,
            isRowWiseAdditionalFeeEnabled: this.templates?.labels_table[10]?.isChecked ?? false,
            isRowWiseDiscountEnabled: this.templates?.labels_table[6]?.isChecked ?? false,
        };
        this.productCalculationUtilityService.calculateBundleProductSubtotal(data);
        this.calculateOrderTotal();
    }
    calculateBundleProductsSubTotal(bundle, item, qty, type) {
        if (type == "discounttype") {
            item.discount = item?.discountType?.discountValue ?? 0;
        } else if (type == "additionalFeeType") {
            item.additionalFee = item?.additionalFeeType?.discountValue ?? 0;
        } else if (type == "baseSubTotal") {
            const uomValue = item?.unit?.uomDetail?.value || 1;
            item.price = item.baseSubTotal / (Number(item.ordQty) * Number(uomValue));
        } else if (type == "price" && item.price == 0) {
            item.discount = 0;
            item.additionalFee = 0;
            item.discountType = null;
            item.additionalFeeType = null;
        }

        if (bundle.typeId == this.typeIds.BundleTypeId) {
            const uomValue = item && item.unit && item.unit.uomDetail && item.unit.uomDetail.value ? item.unit.uomDetail.value : 1;
            item.totalQuantity = Number(qty) * Number(uomValue);
            this.onChangeBundleProductTaxOrDiscount(bundle, item, type);
        }
    }
    onChangeUom(product, uom) {
        product.subTotal = 0;
        if (product.typeId != this.typeIds.BundleTypeId) {
            product.totalQuantity = Number(product.ordQty) * Number(uom?.uomDetail?.value || 1);
            if (product.accountPriceTier?.length > 0) {
                product.price = this.utilityService.applyPriceBook(this.aggregateDiscount, product, product.totalQuantity);
                product.price = product.price * (this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate);
            }
            this.onChangeProductTaxOrDiscount(product, "");
            // this.utilityService.calculateProductsSubTotal(product, this.type, this.allTaxRates, SOChannel.ESTIMATES, this.aggregateDiscount, this.isVisibleRowTax, this.footerTaxEnabled);
        }
        this.calculateOrderTotal();
    }
    onChangeBundleUom(bundle, data, uom) {
        data.totalQuantity = Number(data.ordQty) * Number(uom?.uomDetail?.value || 1);
        this.onChangeBundleProductTaxOrDiscount(bundle, data, "");
    }
    calculateProductsTax(taxRate: number, subTotal: number, product: any) {
        let totalAmount: number = subTotal;
        let appliedDiscount = this.discountOptions?.find((discount) => discount.id == product?.discountType?.id ?? 0);
        /** If checked, sale tax will be calculated on the order total after discount has been applied. */
        if (appliedDiscount && appliedDiscount.isTaxable) {
            if (this.discountEnabled) {
                totalAmount -= Number(product.discountAmount);
            }
            if (this.templates?.labels_table[10]?.isChecked && product?.additionalFeeType?.isTaxable) {
                totalAmount += product?.additionalFeeAmount ?? 0;
            }
            return totalAmount * (Number(taxRate) / 100);
        } else {
            if (this.templates?.labels_table[10]?.isChecked && product?.additionalFeeType?.isTaxable) {
                totalAmount += product?.additionalFeeAmount ?? 0;
            }
            return totalAmount * (Number(taxRate) / 100);
        }
    }
    /** End Amount Calculation */

    onDialogClose() {
        this.cancel.emit(false);
    }

    checkRequired(name, cf_list) {
        return cf_list.find((el) => el.name == name)?.isRequired || false;
    }

    /** Scan Information */
    openScanInfo(product) {
        this.nameLists = [];
        this.selectedProductForScan = _.cloneDeep(product);
        this.selectedBundleForScan = null;
        this.displayScanInfo = true;
        const data = product.creditMemoProductSerialDetails && product.creditMemoProductSerialDetails.length > 0 ? product.creditMemoProductSerialDetails[0] : null;
        this.trackingForm.patchValue({
            lotNo: data?.lotNumber ? data.lotNumber : "",
            revisionNo: data?.revisionNumber ? data.revisionNumber : "",
            expiration: data?.expirationDate ? new Date(data.expirationDate) : new Date(),
        });
        const arr: any[] = [];
        product?.creditMemoProductSerialDetails?.forEach((element) => {
            const obj = {
                id: element.id,
                serialNo: element.barcode,
                lotNo: element.lotNumber,
                revisionNo: element.revisionNumber,
                expiration: element.expirationDate,
            };
            arr.push(obj);
        });
        this.nameLists = arr;
    }

    openScanInfoForBundle(bundle, product) {
        this.nameLists = [];
        this.selectedProductForScan = _.cloneDeep(product);
        this.selectedBundleForScan = _.cloneDeep(bundle);
        this.displayScanInfo = true;
        const data = product.cmBundleProductSerialDetail && product.cmBundleProductSerialDetail.length > 0 ? product.cmBundleProductSerialDetail[0] : null;
        this.trackingForm.patchValue({
            lotNo: data?.lotNumber ? data.lotNumber : "",
            revisionNo: data?.revisionNumber ? data.revisionNumber : "",
            expiration: data?.expirationDate ? new Date(data.expirationDate) : new Date(),
        });
        const arr: any[] = [];
        product.cmBundleProductSerialDetail.forEach((element) => {
            const obj = {
                id: element.id,
                serialNo: element.barcode,
                lotNo: element.lotNumber,
                revisionNo: element.revisionNumber,
                expiration: element.expirationDate,
            };
            arr.push(obj);
        });
        this.nameLists = arr;
    }

    countNameList(value) {
        this.nameLists.push(value);
        this.listLength = this.listLength + 1;
        this.trackingForm.controls["serialNo"].setValue("");
    }

    removeNumber(i) {
        this.nameLists.splice(i, 1);
        this.listLength--;
    }

    saveSerializedNo(c) {
        // bundle items
        if (this.selectedBundleForScan && this.selectedBundleForScan.typeId && (this.selectedBundleForScan.typeId == this.typeIds.BundleTypeId || this.selectedBundleForScan.typeId == this.typeIds.KitTypeId)) {
            this.purchaseListTB.forEach((element) => {
                if (element.id == this.selectedBundleForScan.id) {
                    element.bundleDetails.forEach((b) => {
                        if (this.type == DialogType.CREATE) {
                            if (b.id == this.selectedProductForScan.id) {
                                b.cmBundleProductSerialDetail = [];
                                this.nameLists.forEach((nl) => {
                                    const obj = {
                                        id: 0,
                                        createdSource: this.app.userIP,
                                        updatedSource: this.app.userIP,
                                        createdBy: this.app.userId,
                                        updatedBy: this.app.userId,
                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                        creditMemoId: 0,
                                        creditMemoProductId: 0,
                                        barcode: nl.serialNo,
                                        lotNumber: nl.lotNo,
                                        revisionNumber: nl.revisionNo,
                                        expirationDate: this.app._saveDateTimeWithZone(nl.expiration),
                                        statusId: 1,
                                        shipped: true,
                                    };
                                    b.cmBundleProductSerialDetail.push(obj);
                                });
                            }
                        } else {
                            if (b.rowId == this.selectedProductForScan.rowId) {
                                b.cmBundleProductSerialDetail = [];
                                this.nameLists.forEach((nl) => {
                                    const obj = {
                                        id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                                        createdSource: this.app.userIP,
                                        updatedSource: this.app.userIP,
                                        createdBy: this.app.userId,
                                        updatedBy: this.app.userId,
                                        createdDate: this.app._saveDateTimeWithZone(new Date()),
                                        updatedDate: this.app._saveDateTimeWithZone(new Date()),
                                        creditMemoId: 0,
                                        creditMemoProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                                        creditMemoBundleDetailId: b.rowId ? b.rowId : 0,
                                        barcode: nl.serialNo,
                                        lotNumber: nl.lotNo,
                                        revisionNumber: nl.revisionNo,
                                        expirationDate: this.app._saveDateTimeWithZone(nl.expiration),
                                        statusId: 1,
                                        shipped: true,
                                    };
                                    b.cmBundleProductSerialDetail.push(obj);
                                });
                            }
                        }
                    });
                }
            });
        } else {
            this.purchaseListTB.forEach((element) => {
                if (element.id == this.selectedProductForScan.id) {
                    element.creditMemoProductSerialDetails = [];
                    this.nameLists.forEach((nl) => {
                        const obj = {
                            id: this.type == DialogType.EDIT ? (nl?.id ? nl.id : 0) : 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.userId,
                            updatedBy: this.app.userId,
                            createdDate: this.app._saveDateTimeWithZone(new Date()),
                            updatedDate: this.app._saveDateTimeWithZone(new Date()),
                            creditMemoId: 0,
                            creditMemoProductId: this.type == DialogType.EDIT ? element?.rowId : 0,
                            barcode: nl.serialNo,
                            lotNumber: nl.lotNo,
                            revisionNumber: nl.revisionNo,
                            expirationDate: this.app._saveDateTimeWithZone(nl.expiration),
                            statusId: 1,
                            shipped: true,
                        };
                        element.creditMemoProductSerialDetails.push(obj);
                    });
                }
            });
        }
        this.selectedProductForScan = null;
        this.selectedBundleForScan = null;
        this.displayScanInfo = false;
    }
    /** End Scan Information */

    checkTaxDiscountVisibility() {
        this.isVisibleRowTax = this.templates?.labels_table[5]?.isChecked;
        this.isVisibleRowDiscount = !this.templates?.labels_table[6]?.isChecked;
        this.isVisibleFooterTax = this.templates["labels_footer"] && this.templates["labels_footer"].length >= 3 ? this.templates["labels_footer"][2]?.isChecked : false;
        this.isVisibleFooterDiscount = this.templates["labels_footer"][1]?.isChecked ?? false;
    }

    isNumberKey(evt, product?, type?) {
        if (type == "price" || type == "baseSubtotal") {
            product.minPrice = 0;
            product.minBaseSubtotal = 0;
            if (product?.typeId == TypeIds.ServiceTypeId) {
                let inventoryOrNonInventoryProducts = this.purchaseListTB?.filter((p) => p?.typeId == TypeIds.InventoryTypeId || p?.typeId == TypeIds.NonInventoryTypeId);
                if (inventoryOrNonInventoryProducts && inventoryOrNonInventoryProducts?.length > 0) {
                    product.minPrice = -999999999999.9999;
                    product.minBaseSubtotal = -999999999999.9999;
                    return this.utilityService.allowPositiveOrNegativeNumber(evt);
                }
                return this.utilityService.allowPositiveNumberOnly(evt);
            }
            return this.utilityService.allowPositiveNumberOnly(evt);
        }
        return this.utilityService.allowPositiveNumberOnly(evt);
    }

    onEnterDownStopPropagation(event) {
        event.stopPropagation();
    }

    initCustomFields() {
        this.combinedCustomFields.billing_address_item = [];
        this.combinedCustomFields.shipping_address_item = [];
        this.combinedCustomFields.misc_item = [];
        this.combinedCustomFields.section_item = [];
        this.combinedCustomFields.footer_item = [];
        this.combinedCustomFields.message_item = [];
        this.combinedCustomFields.other1_item = [];
        this.combinedCustomFields.other2_item = [];
        this.combinedCustomFields.other3_item = [];
    }

    getColsCount() {
        this.cols = 0;
        if (this.templates && this.templates.labels_table) {
            this.templates.labels_table.forEach((e) => {
                this.cols += e && e.isChecked ? 1 : 0;
            });
        }
        this.cols -= 1;
    }

    onClearLocation() {
        if (this.allLocations && this.allLocations.length) {
            this.estForm.controls["location"].setValue(this.allLocations.filter((l) => l.isDefault == true)[0]);
        }
    }

    checkBundleExists() {
        return false;
    }

    loadShippingTerm() {
        this.appMainService.isShowSpinner("loadShippingTerm");
        this.shippingtermService
            .getShippingTermList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadShippingTerm");
                    this.allShippingTerms = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadShippingTerm");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllUser() {
        this.appMainService.isShowSpinner("loadAllUser");
        this.salesOrderService
            .getAllUser()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadAllUser");
                    this.allUser = res;
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllUser");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllLocation() {
        this.allLocations = [];
        this.appMainService.isShowSpinner("loadAllLocation");
        this.salesOrderService
            .getAllLocations("0", "0", "")
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.appMainService.isHideSpinner("loadAllLocation");
                    if (res && res.length > 0) {
                        this.allLocations = res?.map((l) => ({
                            ...l,
                            name: l.locationId + " - " + l.name,
                            contactName: l.contactPersonName,
                            qty: l.qtyInStock,
                        }));
                        if (this.type == DialogType.CREATE) {
                            this.allLocations = this.allLocations?.filter((l) => l.statusId == 1);
                            this.estForm.controls["location"].setValue(this.allLocations?.filter((l) => l.isDefault == true)[0]);
                        }
                    }
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllLocation");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    getDiscountSelection(name) {
        this.appMainService.isShowSpinner("getDiscountSelection");
        this.salesOrderService
            .getAllDiscountOption(name)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    const aggregateDiscountValue = res?.filter((o) => o.name == "Aggregate Discount" && o.isDefault == true)[0];
                    this.aggregateDiscount = aggregateDiscountValue ? true : false;
                    this.appMainService.isHideSpinner("getDiscountSelection");
                },
                error: () => {
                    this.appMainService.isHideSpinner("getDiscountSelection");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    loadAllTiers() {
        this.appMainService.isShowSpinner("loadAllTiers");
        this.productsService
            .getAllTiers()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.pricebookConfig = res.item1;
                    this.appMainService.isHideSpinner("loadAllTiers");
                },
                error: () => {
                    this.appMainService.isHideSpinner("loadAllTiers");
                    this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
                },
            });
    }
    getAllAccounts(channelId) {
        this.appMainService.isShowSpinner("loadSOAccounts");
        this.salesOrderService
            .getAccountsByChannelId(channelId, "")
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((responseData) => {
                this.appMainService.isHideSpinner("loadSOAccounts");
                this.allAccounts = responseData;
            });
    }
    getAllCustomAttributes() {
        this.appMainService.isShowSpinner("loadCustomAttributes");
        this.productsService
            .getAllCustomFields(this.orderObjId)
            .then((fields) => {
                this.allCustomAttributes = _.cloneDeep(fields);
                this.appMainService.isHideSpinner("loadCustomAttributes");
            })
            .catch((error) => {
                this.appMainService.isHideSpinner("loadCustomAttributes");
            });
    }

    setAllTaxData(res) {
        this.footerTaxEnabled = res?.item1;
        if (res?.item1) {
            this.allTax = res?.item2;
            if (this.allTax && this.allTax.length > 0) {
                this.taxDesc = this.allTax.filter((t) => t.isDefault == true)[0];
            }
        }
    }
    setShippingTermData(res) {
        if (res) {
            this.allShippingTerms = res;
        }
    }
    setAllUserData(res) {
        if (res) {
            this.allUser = res;
        }
    }
    setAllLocationData(res) {
        this.allLocations = [];
        if (res && res.length > 0) {
            this.allLocations = res?.map((l) => ({
                ...l,
                name: l.locationId + " - " + l.name,
                contactName: l.contactPersonName,
                qty: l.qtyInStock,
            }));
            if (this.type == DialogType.CREATE) {
                this.allLocations = this.allLocations?.filter((l) => l.statusId == 1);
                this.estForm.controls["location"].setValue(this.allLocations?.filter((l) => l.isDefault == true)[0]);
            }
        }
    }
    setOrderChannelData(res) {
        if (res) {
            const config = JSON.parse(res.configurationDetails[0].configJSONValue);
            this.orderChannels = config;
            const filteredStatus = this.orderChannels?.filter((s) => s.name == this.soChannel.ESTIMATES)[0].status;
            this.allStatus = filteredStatus[0].status;
            this.filterStatus();
        }
    }
    filterStatus() {
        if (this.type == DialogType.CREATE || this.type == DialogType.COPY) {
            this.allStatus = this.allStatus?.filter((s) => !["approved", "rejected"].includes(s?.name?.toLowerCase()));
            if (this.allStatus && this.allStatus.length > 0) {
                this.estForm.controls["estimateStatusId"].setValue(this.allStatus[0]);
            }
        } else if (this.type == DialogType.EDIT) {
            if (this.estDetails?.approvalStatusId == ApprovalStatus.Default) {
                this.allStatus = this.allStatus?.filter((s) => !["approved", "rejected"].includes(s?.name?.toLowerCase()));
            } else if (this.estDetails?.approvalStatusId == ApprovalStatus.Approved) {
                this.allStatus = this.allStatus?.filter((s) => ["presented", "accepted", "denied"].includes(s?.name?.toLowerCase()));
            } else if (this.estDetails?.approvalStatusId == ApprovalStatus.Pending || this.estDetails?.approvalStatusId == ApprovalStatus.PartiallyApproved) {
                this.allStatus = this.allStatus?.filter((s) => ["in review", "needs review"].includes(s?.name?.toLowerCase()));
            } else if (this.estDetails?.approvalStatusId == ApprovalStatus.Declined) {
                this.allStatus = this.allStatus?.filter((s) => ["rejected"].includes(s?.name?.toLowerCase()));
            }
        }
    }
    setDiscountSelectionData(res) {
        if (res) {
            const aggregateDiscountValue = res?.filter((o) => o.name == "Aggregate Discount" && o.isDefault == true)[0];
            this.aggregateDiscount = aggregateDiscountValue ? true : false;
        }
    }
    setAllTiersData(res) {
        if (res) {
            this.pricebookConfig = res.item1;
        }
    }
    setAdditionalDiscounts(addDiscounts) {
        this.discountOptions = [];
        this.additionalDiscounts = [];
        if (addDiscounts && addDiscounts.length > 0) {
            this.additionalDiscounts = addDiscounts?.map((l) => ({ ...l, additionalDescription: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
            this.additionalDiscountRateTypes = [];
            this.discountOptions = this.utilityService.prepareDiscountOptions(addDiscounts);
        }
    }

    setAdditionalFees(addFees) {
        this.additionalFees = addFees?.map((l) => ({ ...l, additionalname: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
    }
    setAddressTypes(types) {
        if (types && types.length) {
            this.billingAddressType = types.filter((t) => t.name?.toLowerCase() == "billing")[0];
            this.shippingAddressType = types.filter((t) => t.name?.toLowerCase() == "shipping")[0];
        }
    }
    setAccountChannels(res) {
        this.accountChannels = res;
    }
    setDiscountConfig(res) {
        this.discountEnabled = res.item1;
    }
    setShippingMethods(shippingMethods) {
        this.allShippingMethods = shippingMethods?.filter((m) => m.statusId == Status.Active);
        this.shippingMethods = this.utilityService.prepareShippingMethods(this.allShippingMethods);
    }
    setTemplate(configs) {
        const allTemplates = JSON.parse(configs.configurationDetails[0].configJSONValue);
        this.templates = allTemplates?.filter((t) => t.typeId == TemplateType.Estimate)[0];
        this.checkTaxDiscountVisibility();
        this.getColsCount();
    }

    private handleError(apiName: string, error: any) {
        this.appMainService.isHideSpinner("loadData");
        this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        return of(null);
    }

    getPickListValues(values) {
        return values;
    }

    // find section by code
    getFilteredSectionsByType(code: string): string {
        return this.filteredSection?.find((s) => s.code == code)?.name ?? "";
    }

    onEstimateDateChange(event: any): void {
        this.minExpiryDate = null;
        const estimateDate = event;
        if (estimateDate) {
            const expiryDate = new Date(estimateDate);
            expiryDate.setDate(expiryDate.getDate() + 1);
            this.estForm.controls.expiryDate.setValue(expiryDate);
            this.setMinExpiryDate(estimateDate);
        }
    }
    setMinExpiryDate(estimateDate: Date): void {
        this.minExpiryDate = estimateDate;
    }

    /** Multicurrency */
    getcurrencyExchangeRate() {
        this.currencyExchangeRate = this.orgCurrency?.find((cr) => cr.currencyId == this.accountInfo?.currencyId)?.exchangeRate;
        this.previousCurrencyExchangeRate = this.orgCurrency?.find((cr) => cr.currencyId == this.accountInfo?.currencyId)?.exchangeRate;
        if (this.type && (this.type == DialogType.EDIT || (this.type && this.type == DialogType.COPY))) {
            this.currencyExchangeRate = this.savedCurrencyExchangeRate;
            this.previousCurrencyExchangeRate = this.savedCurrencyExchangeRate;
        }
    }

    closeCurrencyDialog(event: any) {
        this.currencyExchangeRate = event?.formData?.exchangeRate;
        if (event?.formData?.enableRecalculateItemRate) {
            this.onChangeCurrencyRecalculateAmount();
        }
        this.overlayPanel.hide();
    }

    isBaseCurrency(): boolean {
        return this.baseCurrency?.currencyId == this.accountInfo?.currencyId;
    }
    // footer level & line level fee & discount start
    getSelectedFee(): Fee | null {
        if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE && !this.isFooterDiscount) {
            return this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE ? this.selectedHProduct?.additionalFeeType : this.selectedDProduct?.discountType;
        } else if (!this.isFooterDiscount) {
            return this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE ? this.estForm?.controls["additionalFeeType"]?.value : this.estForm?.controls["additionalDiscountTypeName"]?.value;
        } else if (this.isFooterDiscount) {
            return this.estForm?.controls["discountType"]?.value;
        }
    }

    getFeeList(): Fee[] {
        if (this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE) {
            return this.feeOrDiscountContext === FeeOrDiscountContext.LINE ? this.lineLevelHandlingFees : this.footerLevelHandlingFees;
        } else {
            return this.feeOrDiscountContext === FeeOrDiscountContext.LINE ? this.lineLevelDiscounts : this.footerLevelDiscounts;
        }
    }

    openFooterLevelDiscount(isFooterDiscount?: boolean) {
        //footer level discount & additional discount are different things
        this.feeOrDiscountContext = FeeOrDiscountContext.FOOTER;
        this.footerLevelDiscounts = this.additionalDiscounts.filter((d) => d.discountCategoryId === 2);
        this.currentDialogType = DialogTypeFeeOrDiscount.DISCOUNT;
        this.displayFeeOrDiscountDialog = true;
        this.isFooterDiscount = isFooterDiscount;
    }

    openLineLevelDiscount(product: any) {
        this.feeOrDiscountContext = FeeOrDiscountContext.LINE;
        this.selectedDProduct = product || null;
        this.lineLevelDiscounts = this.discountOptions.filter((d) => d.discountCategoryId === 1);
        this.currentDialogType = DialogTypeFeeOrDiscount.DISCOUNT;
        this.isFooterDiscount = false;
        this.displayFeeOrDiscountDialog = true;
    }

    applyDiscount(discount: any) {
        if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE && !this.isFooterDiscount) {
            this.selectedDProduct.discountType = discount;
            this.selectedDProduct.discount = discount?.discountValue ?? 0;
            this.calculateProductsSubTotal(this.selectedDProduct, this.selectedDProduct.ordQty, "discounttype");
        } else if (!this.isFooterDiscount) {
            const appliedDiscount = JSON.parse(JSON.stringify(discount));
            this.estForm.controls["additionalDiscountTypeName"].setValue(appliedDiscount);
            this.onchangeAdditionalDiscountTypeName();
        } else {
            const appliedDiscount = discount ? { ...discount, name: discount?.type?.name ?? "" } : null;
            this.estForm.controls["discountType"].setValue(appliedDiscount);
            this.estForm.controls["discountValue"].setValue(appliedDiscount?.discountValue ?? 0);
            this.calculateOrderTotal("discounttype");
        }
        this.displayFeeOrDiscountDialog = false;
        this.isFooterDiscount = false;
    }

    openFooterLevelHandlingFees() {
        this.feeOrDiscountContext = FeeOrDiscountContext.FOOTER;
        this.footerLevelHandlingFees = this.additionalFees.filter((d) => d.discountCategoryId === 2 && d.statusId == 1);
        this.currentDialogType = DialogTypeFeeOrDiscount.HANDLING_FEE;
        this.isFooterDiscount = false;
        this.displayFeeOrDiscountDialog = true;
    }

    openLineLevelHandlingFees(product: any) {
        this.feeOrDiscountContext = FeeOrDiscountContext.LINE;
        this.selectedHProduct = product;
        this.lineLevelHandlingFees = this.additionalFees.filter((d) => d.discountCategoryId === 1 && d.statusId == 1);
        this.currentDialogType = DialogTypeFeeOrDiscount.HANDLING_FEE;
        this.isFooterDiscount = false;
        this.displayFeeOrDiscountDialog = true;
    }

    applyHandlingFee(fee: any) {
        if (this.feeOrDiscountContext === FeeOrDiscountContext.LINE) {
            this.selectedHProduct.additionalFeeType = fee;
            this.selectedHProduct.additionalFee = fee?.discountValue ?? 0;
            this.calculateProductsSubTotal(this.selectedHProduct, this.selectedHProduct.ordQty, "additionalFeeType");
        } else {
            this.estForm.controls["additionalFeeType"].setValue(fee);
            this.estForm.controls["additionalFee"].setValue(fee?.discountValue || 0);
            this.calculateOrderTotal("totalAdditionalFeetype");
        }
        this.displayFeeOrDiscountDialog = false;
    }

    onFeeApply(event: Fee): void {
        if (this.currentDialogType === DialogTypeFeeOrDiscount.HANDLING_FEE) {
            this.applyHandlingFee(event);
        } else {
            this.applyDiscount(event);
        }
    }

    // Tax Selection
    openTax(product: any, productType: string) {
        this.currentProduct = product;
        this.currentProductType = productType;
        this.selectedTax = productType == "bundleProduct" ? (product?.bundleDetailSubTax ?? []) : (product?.productSubTax ?? []);
        this.taxDialogContext = "product";
        this.displayTaxSelectionDialog = true;
    }
    openFooterTax() {
        const allTaxes = this.purchaseListTB?.flatMap((product) => {
            return product.typeId === this.typeIds.BundleTypeId ? product.bundleDetails.flatMap((bundle) => bundle.bundleDetailSubTax || []) : product.productSubTax || [];
        });
        this.selectedTax = this.getUniqueTaxes(allTaxes);
        this.taxDialogContext = "footer";
        this.displayTaxSelectionDialog = true;
    }
    private getUniqueTaxes(taxes: any[]): any[] {
        const uniqueTaxMap = new Map();
        taxes?.forEach((tax) => {
            if (!uniqueTaxMap.has(tax.taxId)) {
                uniqueTaxMap.set(tax.taxId, tax);
            }
        });
        return Array.from(uniqueTaxMap.values());
    }
    applyTax(event: TaxSelectionModel) {
        this.displayTaxSelectionDialog = false;
        this.selectedTax = null;

        if (this.taxDialogContext === "product") {
            if (this.currentProduct && this.currentProductType != "bundleProduct") {
                this.currentProduct.productSubTax = event.selectedTaxes;
                this.currentProduct.isManualTaxApplied = true;
            } else {
                this.currentProduct.bundleDetailSubTax = event.selectedTaxes;
                this.currentProduct.isManualTaxApplied = true;
            }
        } else if (this.taxDialogContext === "footer") {
            if(event?.selectedTaxes && event?.selectedTaxes?.length > 0){
                const applicableTax = event?.selectedTaxes?.filter((tax) => tax?.isSelected == false);
                if (this.purchaseListTB && this.purchaseListTB.length > 0) {

                    if(applicableTax && applicableTax.length > 0){
                        this.purchaseListTB.forEach((product) => {
                            if (product.typeId === this.typeIds.BundleTypeId) {
                                product?.bundleDetails?.forEach((bundleItem) => {
                                    if(bundleItem.bundleDetailSubTax && bundleItem.bundleDetailSubTax?.length >= 0){
                                        const previousSelectedTax = event?.selectedTaxes?.filter((tax) => tax?.isSelected == true);
                                        if(previousSelectedTax?.length <= 0){
                                            bundleItem.bundleDetailSubTax = [];
                                        }
                                        applicableTax?.forEach((tax) => {
                                            const existingTax = bundleItem?.bundleDetailSubTax?.find((t) => t.taxId === tax.taxId);
                                            if(!existingTax) {
                                                bundleItem.bundleDetailSubTax?.push(existingTax);
                                            }
                                        });
                                    } else {
                                        bundleItem.bundleDetailSubTax = [];
                                        bundleItem.bundleDetailSubTax?.push(...applicableTax);
                                    }
                                    bundleItem.isManualTaxApplied = true;
                                });
                            } else {
                                if(product.productSubTax && product.productSubTax?.length >= 0){
                                    const previousSelectedTax = event?.selectedTaxes?.filter((tax) => tax?.isSelected == true);
                                    if(previousSelectedTax?.length <= 0){
                                        product.productSubTax = [];
                                    }
                                    applicableTax?.forEach((tax) => {
                                        const existingTax = product?.productSubTax?.find((t) => t.taxId === tax.taxId);
                                        if(!existingTax) {
                                            product.productSubTax?.push(tax);
                                        }
                                    });
                                } else {
                                    product.productSubTax = [];
                                    product.productSubTax?.push(...applicableTax);
                                }
                                product.isManualTaxApplied = true;
                            }
                        });
                    } else {
                        this.purchaseListTB.forEach((product) => {
                            if (product.typeId === this.typeIds.BundleTypeId) {
                                product?.bundleDetails?.forEach((bundleItem) => {
                                    let taxes = [];
                                    event?.selectedTaxes?.forEach((tax) => {
                                        const existingTax = bundleItem.bundleDetailSubTax?.find((t) => t.taxId === tax.taxId);
                                        if(existingTax) {
                                            taxes.push(existingTax);
                                        }
                                    });
                                    bundleItem.bundleDetailSubTax = taxes;
                                    bundleItem.isManualTaxApplied = true;
                                });
                            } else {
                                let taxes = [];
                                event?.selectedTaxes?.forEach((tax) => {
                                    const existingTax = product.productSubTax?.find((t) => t.taxId === tax.taxId);
                                    if(existingTax) {
                                        taxes.push(existingTax);
                                    }
                                });
                                product.productSubTax = taxes;
                                product.isManualTaxApplied = true;
                            }
                        });
                    }
                }
            } else {
                if (this.purchaseListTB && this.purchaseListTB.length > 0) {
                    this.purchaseListTB.forEach((product) => {
                        if (product.typeId === this.typeIds.BundleTypeId) {
                            product?.bundleDetails?.forEach((bundleItem) => {
                                bundleItem.bundleDetailSubTax = event.selectedTaxes;
                                bundleItem.isManualTaxApplied = true;
                            });
                        } else {
                            product.productSubTax = event.selectedTaxes;
                            product.isManualTaxApplied = true;
                        }
                    });
                }
            }
        }

        this.reCalculateProductsTotal("tax");
        this.calculateOrderTotal();
    }
    onCloseTaxSelectionDialog(event: any) {
        this.displayTaxSelectionDialog = false;
    }
    // End of Tax Selection
}
